import styles from '../templates/styles.css?inline';
import quoteFormHtml from '../templates/quote-form.html?raw';
import slabViewHtml from '../templates/slab-view.html?raw';
import { PaymentModal } from './PaymentModal.js';

const ICONS = {
  mapPin: `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>`,
  flag: `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line></svg>`,
  pencil: `<svg viewBox="0 0 24 24" width="12" height="12" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>`,
  arrowRight: `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>`,
  arrowLeft: `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>`,
  star: `<svg viewBox="0 0 24 24" width="10" height="10" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>`,
  check: `<svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`,
  stripe: `<svg viewBox="0 0 352 146" style="width: 32px; height: 16px; fill: currentColor;"><path d="M352 74.3c0-30-14.7-46-41.5-46-27 0-43.5 17.6-43.5 46 0 32.5 16.8 47.7 45.4 47.7 12.3 0 23.4-3 31.8-8.2V96.4c-8 4.4-17.6 6.3-25.5 6.3-15.6 0-23.7-7-24.3-19H351c.3-2.5.9-6.3.9-9.4zm-57.5-13c.4-10 7.8-15 15.6-15 7.6 0 14.5 5 14.5 15H294.5zm-83.3 58.7c7 0 12.8-3 16.3-7.7V120h25.8V29.5H227.5v12.2c-3.6-5-9-8-16.3-8-18.7 0-32.8 16-32.8 44.2 0 29.6 14.2 46 32.8 46zm10.7-22.3c-10 0-16.2-8.5-16.2-22.7 0-14 6.3-22.7 16.2-22.7 10 0 16 8.7 16 22.7.1 14.2-6 22.7-16 22.7zm-99.7 20.3c0 8.8 5 12.6 13.5 12.6 5.3 0 9.7-1 13-2.7V107c-3 1-6.7 1.7-10.4 1.7-5.5 0-7.3-2-7.3-7.5V50.6h17.7V29.5h-17.7V8.5h-25.8v21H92V50.6h13.2v46.7zm-40-62.8h-25.7V120h25.7V50.6zm-12.8-17.7c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-50 83.2c-6 4-13.6 6.3-21.7 6.3-16.2 0-24.7-8-24.7-22 0-18.3 15.8-24 45.4-24v-2c0-8.8-6.3-13.3-17.2-13.3-9.5 0-18.6 3.2-25.7 7.7V17c8-3.7 19.3-5.5 30-5.5 27 0 41.5 13 41.5 39V120h-23.7l-3.6-11.2zm-21.7-18.2c9.7 0 17-5.3 17.5-11.7-10.3 0-21.8 2-21.8 11.2 0 4.5 2 6.5 4.3 6.5zm-55 37.3c9.7 0 18.5-4 24.3-10V120h25.7v-76c0-23.4-15-35.5-39.7-35.5-11.7 0-23.4 3-31.5 7.8v21.5c7.8-4 16.2-6.5 24-6.5 12.6 0 18.8 5.7 18.8 16.5v4c-6.8-1.5-14.7-2.3-22.3-2.3-26.3 0-41.2 13.5-41.2 35.3 0 22.3 15 35.2 41 35.2z"/></svg>`,
  chevronRight: `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`,
  book: `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>`,
  download: `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>`,
  printer: `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>`
};

const FALLBACK_IMAGE = "data:image/png;base64,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";
// const FALLBACK_IMAGE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAACAASURBVHic7d177F/1fd/xJxhsgw025m5zMTeDuRu2ZQts6yWppik0VTvaRmvImpakraZRtaraaZpGNalrNakKabQs6TWk+yNkXRuRDakkTdSYZhebSyAYzB1s7vgK+IJt9sfbJ78v5mf7d77fz/d8zvl8ng/ppVZt4t/5ns+5vM87n8sxSKrBYuAjwI8Aa4DzgWUH/39bgGeBB4G/Ab4OvNn9JkqSpFQ+APwZ8Bbw7hzz1sH/zgc631pJkjS2hcAtwP3M/aZ/uDwK3Ea8QZAkST20Cvhd4A0mv/Efmu3AF4CrO/s1kiTpsOYDNwP3AgdIf+OfLeuATxFvGiRJUoeWA78JvEA3N/3Z8jLxxmHldH+qJEl1Oxb4EHAX8A75bvyHZj/xBuJmYN7Ufr0kSZVZSnTEe4r8N/ujZRNwO3DGNHaEJEk1uJ7oePc2+W/sbbOHeFPxIeCY1DtGkqTSnER0sHuQ/DfxVNlA9Fc4JeF+kiSpCJcRHeo2k/+GPa3sIN5oXJton0mSNEg5hvD1Jc1QwhMm3ouSJA3ECqKj3KvkvxHnzlbgDuDCSXaqJEl9NTqEbx/5b7x9y+hQwuPG3MeSJPXGmUQHuGfIf5MdSjYT/SHOHWN/S5KUVTOEbxf5b6hDjUMJJUmDcDLRse174L95lpbHiTcpy+bcGpIkTdl1xNP+TvLfKEvPLuKtwAfn1DKSJCW2gJkhfLlvirWmGUp44lHaSpKkiV1MdFB7jfw3QBPZRryBueII7SZJUmvNEL67qW/CnqFlLfFm5vhZW1KSpDk4i+h49iz5b2ymXV4k3tScd2ijSpJ0ODcSHc32kv9GZiZLM8HQTTiUUJI0iyVEh7JHyH/TMtPJE8QbndOQJFWvmbDnTfLfoEw32c3MBEOSpIosJDqK3Uf+m5HJm/XEm59FSJKKtYroGPY6+W88pl/ZTrwJugpJUhHmER3A7sUhfGZuWQfcgkMJJWmQlhMdvp4n/w3FDDMvE2+MViJJ6rVmwp67gHfIfwMxZaQZSngz8UZJktQTS4mOXI+S/2Zhys6TxJul05EkZdMM4XuL/DcGU1f24FBCSerUScTT/gPkvwkY8y6wgXgrcArSgDg1pobiSuCXgZ8DTs68LSV4HfjTg//7z+PseCnsAP4c+Dwxo6QkaUzziY5XDuFLl3XEG5QTR/bzgpH9nHv7Skmzn09AkjRnK4DbgVfIfyEvITuJvhLXzmHfX0YMfdvag+0uIVuBO4AL57DvJalKo0P49pH/wl1CHmP8b9NNX4sHe/A7SsjoUMLjWrSDJBXrTOIm9TT5L9IlZLR3eqo+Ps1oi7d78PtKyGbiLcs5bRpBkkrhTSVtNhGfTc5o0QZtnQLcBjzVg99bQqZRrElSL51MvFZ+iPwX3xKS67WyMy6mT/O5ZlmLdpCk3ltNdITaSf4LbQl5hXiFfEGbRpiSZs2FF8i/X0rILuBOYE2bRpCkPnFoWfr0eWiZQzan196jQzYlqbcuJp5OXyP/BbSE7CD6SlzdphEyu5Q4Bt4g//4rIduIY+DyNo0gSV1wCF/6PEp0uFvcoh36ZiFwC3A/+fdnCTnATJ+P41u0gyQldxbx/fdZ8l8cS8huyl1gxoWb0uZF4i3LeW0aQYImYLMEAAAAASUVORK5CYII=";

const PLATFORM_FEE = 3.00;

export class QuoteEngine {
  constructor(sdk, hostElement) {
    this.sdk = sdk;
    this.host = hostElement;
    this.paymentModal = new PaymentModal(sdk);

    // State management for individual widget
    this.step = 1; // Steps: 1 (Form Bar), 2 (Rates Modal Overlay), 3 (Checkout/Payment), 4 (Success)

    // Dynamic Route Rows context
    this.routes = [
      { id: 'origin', type: 'SENDER', label: 'Origin', value: 'Pickup location', placeholder: 'Pickup location', icon: 'mapPin' },
      { id: 'destination', type: 'RECIPIENT', label: 'Destination', value: 'Any Destination', placeholder: 'Any Destination', icon: 'flag' }
    ];

    Object.defineProperty(this, 'from', {
      get: () => this.routes.find(r => r.id === 'origin')?.value || 'Pickup location',
      set: (val) => {
        const originRow = this.routes.find(r => r.id === 'origin');
        if (originRow) originRow.value = val;
      },
      configurable: true
    });
    Object.defineProperty(this, 'to', {
      get: () => this.routes.find(r => r.id === 'destination')?.value || 'Any Destination',
      set: (val) => {
        const destRow = this.routes.find(r => r.id === 'destination');
        if (destRow) destRow.value = val;
      },
      configurable: true
    });

    // Lazy initialization of Address Book Modal container if not already instantiated globally
    if (typeof window !== 'undefined' && !this.sdk.addressBookModalInstance) {
      let adbDiv = document.getElementById('logistics-address-book-modal');
      if (!adbDiv) {
        adbDiv = document.createElement('div');
        adbDiv.id = 'logistics-address-book-modal';
        document.body.appendChild(adbDiv);
      }
      this.sdk.initAddressBookModal({ div_id: 'logistics-address-book-modal' });
    }

    // Input details
    this.packageType = '1'; // '1', '2', '3', or 'custom'
    this.lbs = 17;
    this.oz = 0;
    this.isResidential = true;
    this.isInsured = true;
    this.deliveryConfirmation = 'none';
    this.activeFilter = 'all'; // 'all', 'ground', 'express', 'economy'

    this.loading = false;
    this.quotes = [];
    this.selectedQuote = null;
    this.selectedRate = null;       // Raw rate object from API (carrierAccountId, serviceLevelToken, etc.)
    this.paymentError = '';

    this.customLength = 10;
    this.customWidth = 10;
    this.customHeight = 10;
    this.customWeight = 17 * 16; // 17 lbs in oz

    this.variants = [];

    // Step 3 checkout state
    this.senderInfo = { name: '', email: '', phone: '' };
    this.receiverInfo = { name: '', email: '', phone: '' };
    this.consentChecked = false;
    this.payNowLoading = false;

    // Step 4 success state
    this.shipmentResult = null;

    // Initialize Shadow DOM
    this.shadowRoot = this.host.attachShadow({ mode: 'open' });
    this.init();
  }

  async fetchVariants() {
    try {
      const response = await fetch('https://dev-api.shipdeez.com/api/v1/Tenant/without/package', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tenantCode: this.sdk.tenantId })
      });
      const data = await response.json();
      const results = data?.data?.result || [];

      // Map the Shipdeez tenant-package shape onto the shape the rest of this component
      // expects (previously sourced from the SoapBox variants API). Note: PackageWeight
      // here is already in lbs, but downstream code expects ounces (it divides by 16).
      this.variants = results.map(pkg => ({
        id: pkg.TenantPackageID,
        name: pkg.PackageDisplayName,
        length: pkg.Length,
        width: pkg.Width,
        height: pkg.Height,
        weight: Number(pkg.PackageWeight || 0) * 16,
        imageUrl: '',
        numberAvailable: 1
      }));

      if (this.variants.length > 0) {
        const initial = this.variants[0];
        this.packageType = String(initial.id);
        this.updateWeightFromVariant(initial);
      }
    } catch (err) {
      console.error('Failed to fetch variants:', err);
    }
  }

  updateWeightFromVariant(variant) {
    if (!variant) return;
    const totalOz = variant.weight || 0;
    this.lbs = Math.floor(totalOz / 16);
    this.oz = Math.round(totalOz % 16);
  }

  async loadGoogleMaps() {
    if (window.google && window.google.maps && window.google.maps.places) {
      return;
    }
    const url = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDVlEQy5YG8od9J8koeNEjvqQjbEpU2D3k&libraries=places';
    await this.sdk.lazyLoadScript(url);

    // Inject styles for pac-container into the head of document (outside shadow root) so they affect the google dropdown
    if (!document.getElementById('pac-container-global-styles')) {
      const style = document.createElement('style');
      style.id = 'pac-container-global-styles';
      style.textContent = `
        .pac-container {
          z-index: 100000 !important;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
          font-family: 'Inter', sans-serif;
        }
        .pac-item {
          padding: 8px 12px;
          font-size: 13px;
          color: #475569;
          cursor: pointer;
        }
        .pac-item:hover {
          background-color: #f8fafc;
        }
        .pac-item-query {
          font-size: 13px;
          color: #0f172a;
        }
      `;
      document.head.appendChild(style);
    }
  }

  createSvgElement(svgString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgString, 'image/svg+xml');
    return doc.documentElement;
  }

  findEl(id) {
    let el = this.shadowRoot.getElementById(id);
    if (el) return el;
    if (this.modalOverlayWrapper && this.modalOverlayWrapper.shadowRoot) {
      el = this.modalOverlayWrapper.shadowRoot.getElementById(id);
      if (el) return el;
    }
    return null;
  }

  findEls(selector) {
    const fromMain = Array.from(this.shadowRoot.querySelectorAll(selector));
    let fromModal = [];
    if (this.modalOverlayWrapper && this.modalOverlayWrapper.shadowRoot) {
      fromModal = Array.from(this.modalOverlayWrapper.shadowRoot.querySelectorAll(selector));
    }
    return fromMain.concat(fromModal);
  }

  // Stripe's Payment Element never finishes initializing when mounted inside a Shadow DOM
  // (confirmed: identical clientSecret/key mounts and fires 'ready' instantly in light DOM,
  // but hangs indefinitely inside this widget's shadow root). Work around it by mounting the
  // real Stripe iframe into a light-DOM node appended to document.body, positioned to exactly
  // QuoteEngine helper methods

  renderRouteRows() {
    const container = this.findEl('route-rows-container');
    if (!container) return;

    container.innerHTML = '';
    this.routes.forEach(row => {
      const formGroup = document.createElement('div');
      formGroup.className = 'form-group-bar';

      const label = document.createElement('label');
      label.className = 'bar-label';
      label.textContent = row.label;
      formGroup.appendChild(label);

      const wrapper = document.createElement('div');
      wrapper.className = 'input-wrapper-bar';

      const iconSpan = document.createElement('span');
      iconSpan.className = 'input-icon-bar';
      iconSpan.innerHTML = ICONS[row.icon] || ICONS.mapPin;
      wrapper.appendChild(iconSpan);

      const input = document.createElement('input');
      input.type = 'text';
      input.id = row.id + '-input';
      input.className = 'input-control-bar has-address-book';
      input.value = row.value === row.placeholder ? '' : row.value;
      input.placeholder = row.placeholder;
      input.required = true;

      // Sync typed inputs back to state
      input.addEventListener('input', (e) => {
        row.value = e.target.value || row.placeholder;
      });

      wrapper.appendChild(input);

      // Address Book Trigger Button
      const adbBtn = document.createElement('button');
      adbBtn.type = 'button';
      adbBtn.className = 'btn-address-book';
      adbBtn.innerHTML = ICONS.book;
      adbBtn.title = 'Open Address Book';

      adbBtn.addEventListener('click', (e) => {
        e.preventDefault();

        if (!this.sdk.auth.isLoggedIn()) {
          this.sdk.triggerAuth((authenticated) => {
            if (authenticated) {
              this.openAddressBook(row.id, row.type);
            }
          });
        } else {
          this.openAddressBook(row.id, row.type);
        }
      });

      wrapper.appendChild(adbBtn);
      formGroup.appendChild(wrapper);
      container.appendChild(formGroup);
    });

    this.setupAutocomplete();
  }

  openAddressBook(rowId, rowType) {
    this.sdk.triggerAddressBook(rowId, rowType, (addressObj) => {
      const row = this.routes.find(r => r.id === rowId);
      if (row) {
        row.addressObj = {
          name: addressObj.name || addressObj.company || 'Ronald McDonald',
          street1: addressObj.street1,
          street2: addressObj.street2 || '',
          city: addressObj.city,
          state: addressObj.state,
          country: addressObj.country || 'US',
          zip: addressObj.postalCode || addressObj.zip
        };
        const formatted = `${addressObj.name ? addressObj.name + ': ' : ''}${addressObj.street1}${addressObj.street2 ? ' ' + addressObj.street2 : ''}, ${addressObj.city}, ${addressObj.state} ${addressObj.postalCode}`;
        row.value = formatted;

        const input = this.findEl(rowId + '-input');
        if (input) {
          input.value = formatted;
        }

        // Auto-populate sender/receiver contact info from the address book entry
        const contactName = addressObj.name || addressObj.company || '';
        const contactEmail = addressObj.email || '';
        const contactPhone = addressObj.phoneNumber || addressObj.phone_number || addressObj.phone || '';

        if (rowId === 'origin') {
          // Overwrite senderInfo so the checkout form prefills with these values
          this.senderInfo.name = contactName;
          this.senderInfo.email = contactEmail;
          this.senderInfo.phone = contactPhone;
        } else if (rowId === 'destination') {
          // Overwrite receiverInfo so the checkout form prefills with these values
          this.receiverInfo.name = contactName;
          this.receiverInfo.email = contactEmail;
          this.receiverInfo.phone = contactPhone;
        }

        this.render();
        if (this.step === 2) {
          this.createShipmentOrder();
        }
      }
    });
  }


  setupAutocomplete() {
    if (this.step !== 1) return;
    if (!window.google || !window.google.maps || !window.google.maps.places) return;

    this.routes.forEach(row => {
      const input = this.findEl(row.id + '-input');
      if (input && !input.dataset.autocompleteBound) {
        input.dataset.autocompleteBound = 'true';
        const autocomplete = new window.google.maps.places.Autocomplete(input, {
          types: ['geocode', 'establishment']
        });
        this.patchAutocompleteEvents(input);

        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          row.addressObj = this.parseGooglePlace(place);
          row.value = place.formatted_address || place.name || input.value;
          this.render();
        });
      }
    });
  }

  patchAutocompleteEvents(input) {
    input.addEventListener('keydown', (e) => {
      const pacContainers = document.querySelectorAll('.pac-container');
      let pacOpen = false;
      pacContainers.forEach(container => {
        if (window.getComputedStyle(container).display !== 'none') {
          pacOpen = true;
        }
      });

      if (pacOpen && e.key === 'Enter') {
        e.preventDefault();
      }

      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === 'Escape') {
        const clonedEvent = new KeyboardEvent(e.type, {
          key: e.key,
          code: e.code,
          keyCode: e.keyCode,
          which: e.which,
          bubbles: true,
          cancelable: true
        });
        Object.defineProperty(clonedEvent, 'target', { value: input, enumerable: true });
        window.dispatchEvent(clonedEvent);
        document.dispatchEvent(clonedEvent);
      }
    });
  }

  init() {
    // Append styles
    const styleEl = document.createElement('style');
    styleEl.textContent = styles;
    this.shadowRoot.appendChild(styleEl);

    // Create wrapper
    this.container = document.createElement('div');
    this.container.className = 'widget-outer-box';
    this.shadowRoot.appendChild(this.container);

    this.loadGoogleMaps().then(() => {
      this.setupAutocomplete();
    }).catch(err => {
      console.error('Failed to load Google Maps:', err);
    });

    this.fetchVariants().then(() => {
      this.render();
    });

    this.render();
  }

  // Inject icons into template string placeholders
  injectIcons(htmlString) {
    return htmlString
      .replace(/__ICON_MAP_PIN__/g, ICONS.mapPin)
      .replace(/__ICON_FLAG__/g, ICONS.flag)
      .replace(/__ICON_PENCIL__/g, ICONS.pencil)
      .replace(/__ICON_ARROW_LEFT__/g, ICONS.arrowLeft)
      .replace(/__ICON_ARROW_RIGHT__/g, ICONS.arrowRight)
      .replace(/__ICON_CHECK__/g, ICONS.check)
      .replace(/__ICON_STRIPE__/g, ICONS.stripe)
      .replace(/__ICON_DOWNLOAD__/g, ICONS.download)
      .replace(/__ICON_PRINTER__/g, ICONS.printer);
  }

  // Parse slab-view html templates
  getTemplate(templateId) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(slabViewHtml, 'text/html');
    const template = doc.getElementById(templateId);
    return template ? template.innerHTML : '';
  }

  createCarrierCard(quote, isCheapest) {
    if (isCheapest) {
      const card = document.createElement('div');
      card.className = `cheapest-featured-box ${this.selectedQuote && this.selectedQuote.id === quote.id ? 'selected' : ''}`;
      card.setAttribute('data-carrier-id', quote.id);

      const badge = document.createElement('div');
      badge.className = 'cheapest-badge-label';
      badge.appendChild(this.createSvgElement(ICONS.star));
      const badgeText = document.createElement('span');
      badgeText.textContent = 'SHIPDEEZ PICK • CHEAPEST';
      badge.appendChild(badgeText);
      card.appendChild(badge);

      const leftDetails = document.createElement('div');
      leftDetails.className = 'carrier-details-left';

      const logo = document.createElement('div');
      logo.className = `carrier-badge-logo ${quote.carrier}`;
      logo.textContent = quote.carrier.toUpperCase();
      leftDetails.appendChild(logo);

      const infoDesc = document.createElement('div');
      infoDesc.className = 'carrier-info-desc';

      const nameTitle = document.createElement('span');
      nameTitle.className = 'carrier-name-title';
      nameTitle.textContent = quote.name;
      infoDesc.appendChild(nameTitle);

      const textSubinfo = document.createElement('span');
      textSubinfo.className = 'carrier-text-subinfo';
      textSubinfo.textContent = quote.desc;
      infoDesc.appendChild(textSubinfo);

      const etaTitle = document.createElement('span');
      etaTitle.className = 'carrier-eta-title';
      etaTitle.appendChild(this.createSvgElement('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>'));
      const etaText = document.createElement('span');
      etaText.textContent = ` ${quote.eta} • ${quote.time}`;
      etaTitle.appendChild(etaText);
      infoDesc.appendChild(etaTitle);

      leftDetails.appendChild(infoDesc);
      card.appendChild(leftDetails);

      const rightPricing = document.createElement('div');
      rightPricing.className = 'cheapest-pricing-right';

      const priceText = document.createElement('span');
      priceText.className = 'cheapest-price-text';
      priceText.textContent = `$${quote.price.toFixed(2)}`;
      rightPricing.appendChild(priceText);

      const priceSubtext = document.createElement('span');
      priceSubtext.className = 'cheapest-price-subtext';
      priceSubtext.textContent = 'incl. enterprise discount';
      rightPricing.appendChild(priceSubtext);

      const selectBtn = document.createElement('button');
      selectBtn.type = 'button';
      selectBtn.className = 'btn-select-orange btn-carrier-select-trigger';
      selectBtn.setAttribute('data-carrier-id', quote.id);
      const btnSpan = document.createElement('span');
      btnSpan.textContent = 'Select ';
      selectBtn.appendChild(btnSpan);
      selectBtn.appendChild(this.createSvgElement(ICONS.arrowRight));
      rightPricing.appendChild(selectBtn);

      card.appendChild(rightPricing);
      return card;
    } else {
      const card = document.createElement('div');
      card.className = `carrier-row-card ${this.selectedQuote && this.selectedQuote.id === quote.id ? 'active' : ''}`;
      card.setAttribute('data-carrier-id', quote.id);

      const leftDetails = document.createElement('div');
      leftDetails.className = 'carrier-details-left';

      const logo = document.createElement('div');
      logo.className = `carrier-badge-logo ${quote.carrier}`;
      logo.textContent = quote.carrier.toUpperCase();
      leftDetails.appendChild(logo);

      const infoDesc = document.createElement('div');
      infoDesc.className = 'carrier-info-desc';

      const nameTitle = document.createElement('span');
      nameTitle.className = 'carrier-name-title';
      nameTitle.textContent = quote.name;

      if (quote.tag) {
        const tagSpan = document.createElement('span');
        tagSpan.style.marginLeft = '8px';
        tagSpan.style.background = '#e0f2fe';
        tagSpan.style.color = '#0369a1';
        tagSpan.style.fontSize = '8px';
        tagSpan.style.fontWeight = '800';
        tagSpan.style.padding = '2px 6px';
        tagSpan.style.borderRadius = '4px';
        tagSpan.style.textTransform = 'uppercase';
        tagSpan.textContent = quote.tag;
        nameTitle.appendChild(tagSpan);
      }
      infoDesc.appendChild(nameTitle);

      const textSubinfo = document.createElement('span');
      textSubinfo.className = 'carrier-text-subinfo';
      textSubinfo.textContent = `${quote.time} • ${quote.desc}`;
      infoDesc.appendChild(textSubinfo);

      leftDetails.appendChild(infoDesc);
      card.appendChild(leftDetails);

      const rightPricing = document.createElement('div');
      rightPricing.className = 'carrier-row-pricing';

      const priceText = document.createElement('span');
      priceText.className = 'carrier-row-price-text';
      priceText.textContent = `$${quote.price.toFixed(2)}`;
      rightPricing.appendChild(priceText);

      const chevron = document.createElement('div');
      chevron.className = 'carrier-row-chevron';
      chevron.appendChild(this.createSvgElement(ICONS.chevronRight));
      rightPricing.appendChild(chevron);

      card.appendChild(rightPricing);
      return card;
    }
  }

  // Build the checkout form HTML for Step 3
  async renderCheckoutForm(modalMain) {
    const meta = this.shipmentMetaResult;
    const fromAddr = (meta && meta.address) ? meta.address.find(a => a.addressType === 'FROM') : null;
    const toAddr = (meta && meta.address) ? meta.address.find(a => a.addressType === 'TO') : null;

    const senderNameVal = fromAddr?.name || this.senderInfo.name || 'Joe McCarthy';
    const senderPhoneVal = fromAddr?.phone || this.senderInfo.phone || '13179226397';
    const senderEmailVal = fromAddr?.email || this.senderInfo.email || 'jmcca@backhauldirect.com';

    const receiverNameVal = toAddr?.name || this.receiverInfo.name || 'IDCS';
    const receiverPhoneVal = toAddr?.phone || this.receiverInfo.phone || '1234567891';
    const receiverEmailVal = toAddr?.email || this.receiverInfo.email || 'sendto@Shipdeez.com';

    const rate = this.selectedRate;
    const rateAmtVal = meta?.rateAmount !== undefined && meta?.rateAmount !== null
      ? Number(meta.rateAmount)
      : (rate ? parseFloat(rate.rateAmount || rate.price || 0) : 0);

    const carrierRate = isNaN(rateAmtVal) ? 0 : rateAmtVal;
    const total = carrierRate;

    const formatUSD = (v) => `$${Number(v || 0).toFixed(2)}`;

    const pkg0 = (meta && meta.packages && meta.packages[0]) ? meta.packages[0] : null;
    const routeVal = (fromAddr && toAddr)
      ? `${fromAddr.city || ''}, ${fromAddr.state || ''} → ${toAddr.city || ''}, ${toAddr.state || ''}`
      : '—';
    const serviceVal = this.selectedQuote?.name || pkg0?.epRateId || '—';
    const pkgVal = pkg0
      ? `${pkg0.length}×${pkg0.width}×${pkg0.height} • ${pkg0.packageWeight} ${pkg0.weightUnits}`
      : (meta ? `${meta.packageCount || 1} pkg • ${meta.totalPackageWeight || 0} ${meta.packageUnit || 'LB'}` : '—');

    modalMain.innerHTML = `
      <div style="padding: 10px 0 60px 0;">

        <div class="sidebar-section" style="border: none; padding-bottom: 0;">
          <span class="sidebar-label" style="display: block; margin-bottom: 6px;">Booking Summary</span>
          <div style="background: #0f172a; border-radius: 12px; padding: 16px 18px; margin-bottom: 16px; display: flex; flex-direction: column; gap: 10px;">
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px;">
              <span style="font-size: 11px; font-weight: 600; color: #94a3b8;">Route</span>
              <span style="font-size: 13px; font-weight: 700; color: #ffffff; text-align: right;" id="checkout-route-val">${routeVal}</span>
            </div>
            <div style="height: 1px; background: rgba(255,255,255,0.08);"></div>
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px;">
              <span style="font-size: 11px; font-weight: 600; color: #94a3b8;">Carrier Service</span>
              <span style="font-size: 13px; font-weight: 700; color: #fb923c; text-align: right;" id="checkout-service-val">${serviceVal}</span>
            </div>
            <div style="height: 1px; background: rgba(255,255,255,0.08);"></div>
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px;">
              <span style="font-size: 11px; font-weight: 600; color: #94a3b8;">Package Capacity</span>
              <span style="font-size: 13px; font-weight: 700; color: #ffffff; text-align: right;" id="checkout-pkg-val">${pkgVal}</span>
            </div>
          </div>
        </div>

        <div class="checkout-section" style="margin-bottom: 20px;">
          <div class="checkout-section-label">Sender Information</div>
          <div class="price-breakdown-card" style="gap: 14px; background: #f8fafc;">
            <div class="checkout-field-group">
              <label class="checkout-field-label">Full Name</label>
              <input type="text" id="sender-name" class="checkout-input" value="${senderNameVal}" readonly style="background: #f1f5f9; cursor: not-allowed; color: #475569;" />
            </div>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
              <div class="checkout-field-group">
                <label class="checkout-field-label">Phone Number</label>
                <input type="tel" id="sender-phone" class="checkout-input" value="${senderPhoneVal}" readonly style="background: #f1f5f9; cursor: not-allowed; color: #475569;" />
              </div>
              <div class="checkout-field-group">
                <label class="checkout-field-label">Email</label>
                <input type="email" id="sender-email" class="checkout-input" value="${senderEmailVal}" readonly style="background: #f1f5f9; cursor: not-allowed; color: #475569;" />
              </div>
            </div>
          </div>
        </div>

        <div class="checkout-section" style="margin-bottom: 20px;">
          <div class="checkout-section-label">Receiver Information</div>
          <div class="price-breakdown-card" style="gap: 14px; background: #f8fafc;">
            <div class="checkout-field-group">
              <label class="checkout-field-label">Full Name</label>
              <input type="text" id="receiver-name" class="checkout-input" value="${receiverNameVal}" readonly style="background: #f1f5f9; cursor: not-allowed; color: #475569;" />
            </div>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
              <div class="checkout-field-group">
                <label class="checkout-field-label">Phone Number</label>
                <input type="tel" id="receiver-phone" class="checkout-input" value="${receiverPhoneVal}" readonly style="background: #f1f5f9; cursor: not-allowed; color: #475569;" />
              </div>
              <div class="checkout-field-group">
                <label class="checkout-field-label">Email</label>
                <input type="email" id="receiver-email" class="checkout-input" value="${receiverEmailVal}" readonly style="background: #f1f5f9; cursor: not-allowed; color: #475569;" />
              </div>
            </div>
          </div>
        </div>

        <div class="checkout-section" style="margin-bottom: 20px;">
          <div class="checkout-section-label">Shipping Summary</div>
          <div class="price-breakdown-card">
            <div class="price-row">
              <span class="price-row-label">Carrier Rate (${this.selectedQuote?.name || 'Selected carrier'})</span>
              <span class="price-row-val">${formatUSD(carrierRate)}</span>
            </div>
            <div class="price-row total">
              <span class="price-row-label">Total</span>
              <span class="price-row-val total">${formatUSD(total)}</span>
            </div>
          </div>
        </div>

        <div class="consent-row" style="margin-bottom: 20px;">
          <input type="checkbox" id="consent-checkbox" class="consent-checkbox" ${this.consentChecked ? 'checked' : ''} />
          <label for="consent-checkbox" class="consent-label">
            I confirm that the shipment information provided is accurate and I agree to the
            <a href="#" class="consent-link" onclick="return false;">Shipping Terms and Conditions</a>.
          </label>
        </div>
        <div id="checkout-error-banner-root"></div>

        <button type="button" id="btn-proceed-payment" class="btn-pay-now" ${!this.consentChecked ? 'disabled' : ''}>
          <span>Proceed to Payment (${formatUSD(total)})</span>
        </button>
      </div>
    `;

    const proceedBtn = modalMain.querySelector('#btn-proceed-payment');
    const consentCheckbox = modalMain.querySelector('#consent-checkbox');

    if (consentCheckbox) {
      consentCheckbox.addEventListener('change', (e) => {
        this.consentChecked = e.target.checked;
        if (proceedBtn) {
          proceedBtn.disabled = !this.consentChecked;
        }
      });
    }

    if (proceedBtn) {
      proceedBtn.addEventListener('click', () => {
        if (!this.consentChecked) return;

        this.paymentModal.show({
          totalAmount: total,
          shipmentId: this.shipmentId,
          merchantId: this.shipmentMetaResult?.merchantId || 1,
          currencyCode: this.shipmentMetaResult?.currency || 'USD',
          onSuccess: async (data) => {
            const sessionId = data?.paymentMeta?.sessionId;
            const paymentRefId = data?.paymentMeta?.paymentRefId;

            // Trigger payment validation and prepare-payment flow (Step 3.5)
            this.step = 3.5;
            this.render();
            this.renderVerificationScreen(sessionId, paymentRefId);
          },
          onError: (err) => {
            console.error("Payment error:", err);
          }
        });
      });
    }
  }

  // Build the success screen HTML for Step 4
  renderSuccessScreen(modalMain) {
    const meta = this.shipmentMetaResult;
    const pkg0 = (meta && meta.packages && meta.packages[0]) ? meta.packages[0] : {};
    const fromAddr = (meta && meta.address) ? meta.address.find(a => a.addressType === 'FROM') : null;
    const toAddr = (meta && meta.address) ? meta.address.find(a => a.addressType === 'TO') : null;

    const trackingNumber = pkg0.pieceTrackingNumber || meta?.trackingCode || '1ZXXXXXXXXXXXXXXXX';
    const carrier = this.selectedQuote ? this.selectedQuote.carrier.toUpperCase() : 'UPS®';
    const service = this.selectedQuote ? this.selectedQuote.name : 'UPS_GROUND';
    const createdDate = pkg0.createdAt || 'Today';

    const pdfName = pkg0.predefinedPackage || (pkg0.packageId ? `${pkg0.packageId}.pdf` : null);
    const labelPdfUrl = pdfName ? `https://dev-api.shipdeez.com/api/v1/Shipment/get-label/${pdfName}` : '#';

    const formatUSD = (v) => `$${Number(v || 0).toFixed(2)}`;
    const rateAmt = meta?.rateAmount || (this.selectedQuote ? this.selectedQuote.price : 12.69);
    const totalAmt = rateAmt + PLATFORM_FEE;

    modalMain.innerHTML = `
      <div class="success-pane-light" style="padding: 10px 0;">
        <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
          <div class="success-icon-wrapper-light" style="width: 40px; height: 40px; margin: 0; background: #dcfce7; color: #16a34a; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
            ${ICONS.check}
          </div>
          <div>
            <h2 class="success-title-light" style="font-size: 20px; font-weight: 800; color: #0f172a; margin: 0; text-align: left;">Your Label is Ready!</h2>
            <p class="success-desc-light" style="font-size: 12px; color: #64748b; margin: 0; text-align: left;">Download or print your shipping label below. Keep your tracking number safe.</p>
          </div>
        </div>

        <div style="background: #ffffff; border: 1.5px solid #e2e8f0; border-radius: 14px; padding: 20px; margin-bottom: 20px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05);">
          <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; padding-bottom: 12px; border-bottom: 1px solid #f1f5f9;">
            <div>
              <span style="font-size: 10px; font-weight: 800; color: #64748b; letter-spacing: 0.05em; display: block; margin-bottom: 2px;">TRACKING NUMBER</span>
              <span style="font-family: monospace; font-size: 16px; font-weight: 700; color: #0f172a;">${trackingNumber}</span>
            </div>
            <button type="button" id="btn-copy-tracking" style="height: 34px; padding: 0 14px; border: 1.5px solid #0f172a; border-radius: 8px; background: #ffffff; font-size: 12px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 6px;">
              📋 Copy
            </button>
          </div>

          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px; background: #f8fafc; padding: 14px; border-radius: 10px; margin-bottom: 16px; font-size: 12px;">
            <div>
              <span style="font-size: 10px; font-weight: 700; color: #94a3b8; display: block; text-transform: uppercase;">From</span>
              <strong style="color: #0f172a; display: block;">${fromAddr?.name || 'Joe McCarthy'}</strong>
              <span style="color: #64748b;">${fromAddr?.city || 'Indianapolis'}, ${fromAddr?.state || 'Indiana'}</span>
            </div>
            <div>
              <span style="font-size: 10px; font-weight: 700; color: #94a3b8; display: block; text-transform: uppercase;">To</span>
              <strong style="color: #0f172a; display: block;">${toAddr?.name || 'IDCS'}</strong>
              <span style="color: #64748b;">${toAddr?.city || 'Easton'}, ${toAddr?.state || 'Pennsylvania'}</span>
            </div>
          </div>

          <div style="display: flex; gap: 12px;">
            <button type="button" id="btn-success-print-label" style="flex: 1; height: 44px; border: 1.5px solid #0f172a; border-radius: 8px; background: #ffffff; color: #0f172a; font-size: 13px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 6px;">
              ${ICONS.printer}
              <span>Print Label</span>
            </button>
            <a href="${labelPdfUrl}" target="_blank" download id="btn-success-download-label" style="flex: 1; height: 44px; border-radius: 8px; background: #ea580c; color: #ffffff; font-size: 13px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 6px; text-decoration: none; box-sizing: border-box;">
              ${ICONS.download}
              <span>Download</span>
            </a>
          </div>
        </div>

        <div class="receipt-card-light" style="margin-bottom: 16px;">
          <div class="receipt-row-light">
            <span class="receipt-label-light">Shipping</span>
            <span class="receipt-val-light">${formatUSD(rateAmt)}</span>
          </div>
          <div class="receipt-row-light">
            <span class="receipt-label-light">Fee</span>
            <span class="receipt-val-light">${formatUSD(PLATFORM_FEE)}</span>
          </div>
          <div class="receipt-row-light total">
            <span class="receipt-label-light">Total</span>
            <span class="receipt-val-light total">${formatUSD(totalAmt)}</span>
          </div>
        </div>

        <p style="font-size: 11px; color: #64748b; text-align: center;">A copy of your label has been emailed to your account address.</p>
      </div>
    `;

    // Copy tracking click listener
    const btnCopy = modalMain.querySelector('#btn-copy-tracking');
    if (btnCopy) {
      btnCopy.addEventListener('click', () => {
        navigator.clipboard?.writeText(trackingNumber);
        btnCopy.textContent = '✓ Copied!';
        setTimeout(() => { btnCopy.textContent = '📋 Copy'; }, 2000);
      });
    }

    // Print label click listener
    const btnPrint = modalMain.querySelector('#btn-success-print-label');
    if (btnPrint) {
      btnPrint.addEventListener('click', () => {
        if (labelPdfUrl && labelPdfUrl !== '#') {
          const win = window.open(labelPdfUrl, '_blank');
          win?.print();
        } else {
          alert('Label PDF not available to print.');
        }
      });
    }
  }

  lockBodyScroll() {
    if (!this._bodyScrollLocked && typeof document !== 'undefined' && document.body) {
      this._originalBodyOverflow = document.body.style.overflow;
      this._originalHtmlOverflow = document.documentElement.style.overflow;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      this._bodyScrollLocked = true;
    }
  }

  unlockBodyScroll() {
    if (this._bodyScrollLocked && typeof document !== 'undefined' && document.body) {
      document.body.style.overflow = this._originalBodyOverflow || '';
      document.documentElement.style.overflow = this._originalHtmlOverflow || '';
      this._bodyScrollLocked = false;
    }
  }

  disconnectedCallback() {
    this.unlockBodyScroll();
    if (this.paymentModal) {
      this.paymentModal.hide();
    }
    if (this.modalOverlayWrapper) {
      this.modalOverlayWrapper.remove();
      this.modalOverlayWrapper = null;
      this.modalOverlay = null;
    }
  }

  render() {
    if (this.step === 1) {
      this.unlockBodyScroll();
      if (this.paymentModal) {
        this.paymentModal.hide();
      }
      // Remove modal overlay if it exists
      if (this.modalOverlayWrapper) {
        this.modalOverlayWrapper.remove();
        this.modalOverlayWrapper = null;
        this.modalOverlay = null;
      }

      // Check if horizontal form is not rendered yet
      if (this.container.innerHTML === '') {
        const template = this.injectIcons(quoteFormHtml);
        this.container.innerHTML = template;
      }

      this.renderRouteRows();

      // Render bag selector dropdown dynamically if variants are loaded
      const trigger = this.findEl('bag-dropdown-trigger');
      const triggerText = trigger?.querySelector('.dropdown-trigger-text');
      const menu = this.findEl('bag-dropdown-menu');

      if (this.variants && this.variants.length > 0) {
        const selectedVariant = this.variants.find(v => String(v.id) === String(this.packageType)) || this.variants[0];
        if (triggerText && selectedVariant) {
          triggerText.textContent = `${selectedVariant.name.toUpperCase()} (${selectedVariant.length}x${selectedVariant.width}x${selectedVariant.height} • ${Math.floor(selectedVariant.weight / 16)} lbs)`;
        }

        if (menu) {
          menu.innerHTML = '';
          this.variants.forEach(variant => {
            const item = document.createElement('div');
            item.className = `dropdown-item ${String(variant.id) === String(this.packageType) ? 'selected' : ''}`;
            item.setAttribute('data-pkg', variant.id);

            const leftCol = document.createElement('div');
            leftCol.className = 'dropdown-item-left';

            const img = document.createElement('img');
            img.className = 'dropdown-item-img';
            img.style.padding = (variant.imageUrl && variant.imageUrl.trim() !== '') ? '' : '10px';
            img.src = (variant.imageUrl && variant.imageUrl.trim() !== '') ? variant.imageUrl : FALLBACK_IMAGE;
            img.alt = variant.name;
            leftCol.appendChild(img);

            const rightCol = document.createElement('div');
            rightCol.className = 'dropdown-item-right';

            const nameDiv = document.createElement('div');
            nameDiv.className = 'dropdown-item-name';
            nameDiv.textContent = variant.name.toUpperCase();

            const detailsDiv = document.createElement('div');
            detailsDiv.className = 'dropdown-item-details';
            detailsDiv.textContent = `Dims: ${variant.length}×${variant.width}×${variant.height} • Weight: ${Math.floor(variant.weight / 16)} lbs`;

            rightCol.appendChild(nameDiv);
            rightCol.appendChild(detailsDiv);

            item.appendChild(leftCol);
            item.appendChild(rightCol);
            menu.appendChild(item);
          });
        }
      }

    } else {
      this.lockBodyScroll();
      // For steps 2, 3, and 4, we render inside the body-mounted wrapper's shadow root
      if (!this.modalOverlayWrapper) {
        this.modalOverlayWrapper = document.createElement('div');
        this.modalOverlayWrapper.id = 'shipdeez-modal-wrapper';
        this.modalOverlayWrapper.style.position = 'relative';
        this.modalOverlayWrapper.style.zIndex = '99999';
        document.body.appendChild(this.modalOverlayWrapper);

        const modalShadow = this.modalOverlayWrapper.attachShadow({ mode: 'open' });

        // Inject compiled styles into the modal shadow DOM
        const styleEl = document.createElement('style');
        styleEl.textContent = styles;
        modalShadow.appendChild(styleEl);

        this.modalOverlay = document.createElement('div');
        modalShadow.appendChild(this.modalOverlay);

        // Render the main modal layout structure ONCE
        const rawTemplate = this.getTemplate('rates-modal-template');
        this.modalOverlay.innerHTML = this.injectIcons(rawTemplate);
      }

      const modalMain = this.modalOverlayWrapper.shadowRoot.querySelector('.rates-modal-main');

      // Update the stepper nodes inside the header dynamically
      const stepperNodes = this.findEls('.stepper-node');
      stepperNodes.forEach((node, idx) => {
        node.className = 'stepper-node'; // Reset classes
        const num = idx + 1;
        if (this.step === 2) {
          if (num === 1) node.classList.add('active');
        } else if (this.step === 3) {
          if (num === 1) node.classList.add('completed');
          if (num === 2) node.classList.add('active');
        } else if (this.step === 4) {
          if (num === 1) node.classList.add('completed');
          if (num === 2) node.classList.add('completed');
          if (num === 3) node.classList.add('active');
        }
      });

      // Toggle view-only status of left column sidebar based on steps
      const sidebar = this.modalOverlayWrapper.shadowRoot.querySelector('.modal-sidebar');
      const confirmationSelect = this.findEl('delivery-confirmation-select');
      if (this.step === 2) {
        if (sidebar) sidebar.classList.remove('view-only');
        if (confirmationSelect) confirmationSelect.removeAttribute('disabled');
      } else {
        if (sidebar) sidebar.classList.add('view-only');
        if (confirmationSelect) confirmationSelect.setAttribute('disabled', 'true');
      }

      const btnBack = this.findEl('btn-footer-back');
      const btnContinue = this.findEl('btn-footer-continue-checkout');
      const modalFooter = this.findEl('btn-footer-continue-checkout')?.closest('.rates-modal-footer');

      if (this.step === 2) {
        // Carriers Selection
        if (modalMain) {
          modalMain.innerHTML = `
            <div class="rates-title-header-row">
              <div>
                <h2 class="rates-main-title">Available rates</h2>
                <p class="rates-main-subtitle" id="rates-count-subinfo">Calculate services...</p>
              </div>
              <div class="sort-control-wrapper">
                <span style="font-size: 12px; font-weight: 700; color: #64748b;">SORT</span>
                <select class="select-control" style="width: auto; height: 32px; padding: 4px 10px; margin: 0; font-size: 12px; font-weight: 600;">
                  <option>Cheapest</option>
                  <option>Fastest</option>
                </select>
              </div>
            </div>
            <div class="filter-tabs-row">
              <button type="button" class="filter-tab-button" data-filter="all" id="filter-all-btn">All (0)</button>
              <button type="button" class="filter-tab-button" data-filter="ground">Ground</button>
              <button type="button" class="filter-tab-button" data-filter="express">Express</button>
              <button type="button" class="filter-tab-button" data-filter="economy">Economy</button>
            </div>
            <div id="cheapest-rate-box-root"></div>
            <div class="other-options-title">Other Options</div>
            <div class="other-carriers-list" id="other-carriers-list-root"></div>
          `;
        }

        this.renderRatesData();

        if (modalFooter) modalFooter.style.display = 'flex';
        if (btnBack) {
          btnBack.innerHTML = `${ICONS.arrowLeft} <span>Back to Locations</span>`;
        }
        if (btnContinue) {
          btnContinue.style.display = 'flex';
        }

      } else if (this.step === 3) {
        // Checkout step — render sender/receiver/consent/summary form ONCE
        if (modalMain && !modalMain.querySelector('#btn-pay-now')) {
          this.renderCheckoutForm(modalMain);
        }

        if (modalFooter) modalFooter.style.display = 'flex';
        if (btnBack) {
          btnBack.innerHTML = `${ICONS.arrowLeft} <span>Back to Carriers</span>`;
        }
        if (btnContinue) {
          btnContinue.style.display = 'none'; // Checkout form has its own Pay Now button
        }

      } else if (this.step === 3.5) {
        // Verification & Validation screen
        if (modalFooter) modalFooter.style.display = 'none';

      } else if (this.step === 4) {
        // Success screen
        if (modalMain) {
          this.renderSuccessScreen(modalMain);
        }

        if (modalFooter) modalFooter.style.display = 'none';
      }
    }

    this.bindEvents();
  }

  // Populate dynamic rate items into slab-view layout
  // Sidebar panels (route text, package grid, delivery confirmation, toggles) don't depend
  // on quotes/rates at all, so they're rendered independently of renderRatesData()'s
  // loading-skeleton early-return below — otherwise they'd never update while loading=true.
  renderSidebarPanels() {
    // Set textual properties in sidebar
    const fromTextNode = this.findEl('route-from-text');
    if (fromTextNode) {
      fromTextNode.textContent = this.from;
      const descSpan = document.createElement('span');
      descSpan.className = 'timeline-node-desc';
      descSpan.textContent = 'Pro Shop pickup';
      fromTextNode.appendChild(descSpan);
    }

    const toTextNode = this.findEl('route-to-text');
    if (toTextNode) {
      toTextNode.textContent = this.to;
      const descSpan = document.createElement('span');
      descSpan.className = 'timeline-node-desc';
      descSpan.textContent = 'Residential delivery';
      toTextNode.appendChild(descSpan);
    }

    const lbsInput = this.findEl('weight-lbs-input');
    if (lbsInput) lbsInput.value = this.lbs;
    const ozInput = this.findEl('weight-oz-input');
    if (ozInput) ozInput.value = this.oz;

    // Render package items dynamically once variants are loaded and the initial rates
    // fetch has settled — gating on variants alone made this unreachable in practice,
    // since variants finish loading almost instantly at page init.
    const pkgSection = this.findEl('pkg-section-container');
    const dataReady = !this.loading && this.variants && this.variants.length > 0;

    if (pkgSection && dataReady) {
      if (this.packageType === 'custom') {
        // Render Custom Form
        pkgSection.innerHTML = `
          <div class="sidebar-section-header">
            <span class="sidebar-label">Custom Package</span>
          </div>
          <div class="custom-pkg-form" style="display: flex; flex-direction: column; gap: 10px; margin-top: 10px;">
            <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px;">
              <div>
                <label style="font-size: 10px; color: #64748b; font-weight: 600;">L (in)</label>
                <input type="number" id="custom-length-input" value="${this.customLength}" style="width: 100%; height: 32px; border: 1px solid #e2e8f0; border-radius: 4px; padding: 4px 8px; font-size: 12px; font-weight: 600; box-sizing: border-box;" />
              </div>
              <div>
                <label style="font-size: 10px; color: #64748b; font-weight: 600;">W (in)</label>
                <input type="number" id="custom-width-input" value="${this.customWidth}" style="width: 100%; height: 32px; border: 1px solid #e2e8f0; border-radius: 4px; padding: 4px 8px; font-size: 12px; font-weight: 600; box-sizing: border-box;" />
              </div>
              <div>
                <label style="font-size: 10px; color: #64748b; font-weight: 600;">H (in)</label>
                <input type="number" id="custom-height-input" value="${this.customHeight}" style="width: 100%; height: 32px; border: 1px solid #e2e8f0; border-radius: 4px; padding: 4px 8px; font-size: 12px; font-weight: 600; box-sizing: border-box;" />
              </div>
            </div>
            <div>
              <label style="font-size: 10px; color: #64748b; font-weight: 600;">Weight (lbs)</label>
              <input type="number" id="custom-weight-input" value="${Math.floor(this.customWeight / 16)}" style="width: 100%; height: 32px; border: 1px solid #e2e8f0; border-radius: 4px; padding: 4px 8px; font-size: 12px; font-weight: 600; box-sizing: border-box;" />
            </div>
            <button type="button" id="btn-switch-standard" style="margin-top: 6px; height: 32px; font-size: 11px; font-weight: 700; color: #f97316; border: 1px dashed #f97316; background: #fff7ed; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 4px; box-sizing: border-box;">
              Choose Standard Package
            </button>
          </div>
        `;
      } else {
        // Render Standard Package Grid
        pkgSection.innerHTML = `
          <div class="sidebar-section-header">
            <span class="sidebar-label">Package</span>
            <span style="font-size: 10px; color: #f97316; font-weight: 600; cursor: pointer;">Click for dims</span>
          </div>
          <div class="pkg-grid-sidebar">
            <!-- Dynamic variants populated below -->
          </div>
        `;

        const grid = pkgSection.querySelector('.pkg-grid-sidebar');
        if (grid) {
          this.variants.forEach(variant => {
            const card = document.createElement('div');
            card.className = `pkg-card-sidebar ${String(variant.id) === String(this.packageType) ? 'active' : ''}`;
            card.setAttribute('data-pkg', variant.id);

            // Left side image column
            const leftCol = document.createElement('div');
            leftCol.className = 'dropdown-item-left';
            leftCol.style.width = '36px';
            leftCol.style.height = '36px';

            const img = document.createElement('img');
            img.className = 'dropdown-item-img';
            img.style.padding = (variant.imageUrl && variant.imageUrl.trim() !== '') ? '' : '10px';
            img.src = (variant.imageUrl && variant.imageUrl.trim() !== '') ? variant.imageUrl : FALLBACK_IMAGE;
            img.alt = variant.name;
            leftCol.appendChild(img);

            // Right side details column
            const rightCol = document.createElement('div');
            rightCol.className = 'dropdown-item-right';

            const nameDiv = document.createElement('div');
            nameDiv.className = 'pkg-sidebar-weight';
            nameDiv.textContent = variant.name.toUpperCase();

            const dimsDiv = document.createElement('div');
            dimsDiv.className = 'pkg-sidebar-dims';
            const lbsVal = Math.floor(variant.weight / 16);

            const isOutOfStock = (variant.numberAvailable ?? 0) <= 0;
            if (isOutOfStock) {
              card.classList.add('disabled');
              card.style.opacity = '0.5';
              card.style.pointerEvents = 'none';
              dimsDiv.innerHTML = `
                <div>${variant.length}×${variant.width}×${variant.height} • ${lbsVal} lbs</div>
                <div style="color: #ef4444; font-weight: 800; font-size: 8px; text-transform: uppercase; margin-top: 2px;">OUT OF STOCK</div>
              `;
            } else {
              dimsDiv.textContent = `${variant.length}×${variant.width}×${variant.height} • ${lbsVal} lbs`;
            }

            rightCol.appendChild(nameDiv);
            rightCol.appendChild(dimsDiv);

            card.appendChild(leftCol);
            card.appendChild(rightCol);
            grid.appendChild(card);
          });
        }
      }
    } else if (pkgSection) {
      // Variants haven't loaded yet — show a skeleton instead of the static dummy package cards
      pkgSection.innerHTML = `
        <div class="sidebar-section-header">
          <span class="sidebar-label">Package</span>
        </div>
        <div class="pkg-grid-sidebar">
          ${[0, 1, 2, 3].map(() => `
            <div class="pkg-card-sidebar" style="pointer-events: none; gap: 10px; display: flex; align-items: center;">
              <div style="width: 36px; height: 36px; border-radius: 6px; background: #e2e8f0; animation: pulse 1.4s ease-in-out infinite;"></div>
              <div style="flex: 1; display: flex; flex-direction: column; gap: 6px;">
                <div style="height: 10px; width: 60%; border-radius: 4px; background: #e2e8f0; animation: pulse 1.4s ease-in-out infinite;"></div>
                <div style="height: 8px; width: 40%; border-radius: 4px; background: #edf1f5; animation: pulse 1.4s ease-in-out infinite;"></div>
              </div>
            </div>
          `).join('')}
        </div>
      `;
    }

    // Delivery Confirmation & Toggles sections — same skeleton-while-loading treatment as Package
    const skeletonBar = (width) => `<div style="height: 10px; width: ${width}; border-radius: 4px; background: #e2e8f0; animation: pulse 1.4s ease-in-out infinite;"></div>`;

    const deliverySection = this.findEl('delivery-confirmation-section');
    if (deliverySection) {
      if (dataReady) {
        if (!deliverySection.querySelector('#delivery-confirmation-select')) {
          deliverySection.innerHTML = `
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px;">
              <span class="sidebar-label">Delivery Confirmation</span>
              <select class="select-control" id="delivery-confirmation-select" style="width: auto; height: 32px; padding: 4px 10px; margin: 0; font-size: 12px; font-weight: 600;">
                <option value="none">No confirmation</option>
                <option value="signature">Signature required</option>
                <option value="adult">Adult signature required</option>
              </select>
            </div>
          `;
        }
      } else {
        deliverySection.innerHTML = `
          <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px;">
            <span class="sidebar-label">Delivery Confirmation</span>
            <div style="width: 110px;">${skeletonBar('100%')}</div>
          </div>
        `;
      }
    }

    const togglesSection = this.findEl('toggles-section-container');
    if (togglesSection) {
      if (dataReady) {
        if (!togglesSection.querySelector('#toggle-residential')) {
          togglesSection.innerHTML = `
            <div class="custom-toggle-row">
              <div class="toggle-content-left">
                <span class="toggle-title-head">Residential address</span>
                <span class="toggle-subtitle-desc">Affects rates from some carriers</span>
              </div>
              <div class="toggle-switch-track" id="toggle-residential">
                <div class="toggle-switch-slider"></div>
              </div>
            </div>
            <div class="custom-toggle-row" style="margin-top: 14px; margin-bottom: 0;">
              <div class="toggle-content-left">
                <span class="toggle-title-head">Insure shipment</span>
                <span class="toggle-subtitle-desc">Default coverage up to $1,000</span>
              </div>
              <div class="toggle-switch-track" id="toggle-insurance">
                <div class="toggle-switch-slider"></div>
              </div>
            </div>
          `;
        }
      } else {
        togglesSection.innerHTML = `
          <div style="display: flex; flex-direction: column; gap: 6px;">
            ${skeletonBar('70%')}
            ${skeletonBar('90%')}
          </div>
          <div style="display: flex; flex-direction: column; gap: 6px; margin-top: 14px;">
            ${skeletonBar('55%')}
            ${skeletonBar('80%')}
          </div>
        `;
      }
    }

    // Toggle states visual
    const resToggle = this.findEl('toggle-residential');
    if (resToggle) {
      if (this.isResidential) resToggle.classList.add('active');
      else resToggle.classList.remove('active');
    }

    const insToggle = this.findEl('toggle-insurance');
    if (insToggle) {
      if (this.isInsured) insToggle.classList.add('active');
      else insToggle.classList.remove('active');
    }
  }

  renderRatesData() {
    this.renderSidebarPanels();
    if (this.loading) {
      const cheapestRoot = this.findEl('cheapest-rate-box-root');
      if (cheapestRoot) {
        cheapestRoot.innerHTML = `
          <div style="display: flex; flex-direction: column; gap: 16px; width: 100%; box-sizing: border-box; padding: 10px 0;">
            <div style="display: flex; align-items: center; gap: 12px; padding: 16px; border: 1.5px dashed #cbd5e1; border-radius: 12px; background: #fafafa; animation: pulse-bg 2s infinite ease-in-out;">
              <div class="loading-spinner-glow" style="width: 24px; height: 24px; border: 2.5px solid #f1f5f9; border-top-color: #f97316; border-radius: 50%; animation: spin 0.8s linear infinite;"></div>
              <div style="display: flex; flex-direction: column; gap: 4px; flex: 1;">
                <span id="dynamic-loading-status" style="font-size: 13px; font-weight: 700; color: #0f172a; display: flex; align-items: center; gap: 6px;">
                  Finding the best rates...
                </span>
                <span id="dynamic-loading-substatus" style="font-size: 11px; color: #64748b; font-weight: 500;">Checking carrier parameters. Please wait.</span>
              </div>
            </div>
            
            <!-- Skeleton cards representing loading carriers -->
            <div style="display: flex; flex-direction: column; gap: 10px; width: 100%;">
              <div style="height: 72px; border-radius: 10px; border: 1px solid #e2e8f0; background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; opacity: 0.85;"></div>
              <div style="height: 72px; border-radius: 10px; border: 1px solid #e2e8f0; background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; animation-delay: 0.2s; opacity: 0.6;"></div>
              <div style="height: 72px; border-radius: 10px; border: 1px solid #e2e8f0; background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; animation-delay: 0.4s; opacity: 0.45;"></div>
            </div>
          </div>
        `;

        // Text looping animation logic
        const phrases = [
          { status: "Finding the best rates...", sub: "Querying multiple carriers for standard & priority routes..." },
          { status: "Checking transit options...", sub: "Analyzing optimal shipping path combinations..." },
          { status: "Applying discounts...", sub: "Merging enterprise markdowns and account savings..." },
          { status: "Selecting cheapest rates...", sub: "Sorting results by cost-efficiency..." },
          { status: "Filtering express options...", sub: "Verifying delivery estimates and priority windows..." },
          { status: "Polishing choices...", sub: "Almost ready! Finalizing carrier selections..." }
        ];

        let index = 0;
        if (this._loadingInterval) {
          clearInterval(this._loadingInterval);
        }
        this._loadingInterval = setInterval(() => {
          if (!this.loading) {
            clearInterval(this._loadingInterval);
            return;
          }
          index = (index + 1) % phrases.length;
          const currentStatusEl = this.findEl('dynamic-loading-status');
          const currentSubstatusEl = this.findEl('dynamic-loading-substatus');
          if (currentStatusEl && currentSubstatusEl) {
            currentStatusEl.textContent = phrases[index].status;
            currentSubstatusEl.textContent = phrases[index].sub;
          }
        }, 2200);
      }
      const otherListRoot = this.findEl('other-carriers-list-root');
      if (otherListRoot) {
        otherListRoot.innerHTML = '';
      }

      // Inject custom keyframes dynamically if not present
      if (!this.shadowRoot.getElementById('spin-style')) {
        const spinStyle = document.createElement('style');
        spinStyle.id = 'spin-style';
        spinStyle.textContent = `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes pulse-bg {
            0%, 100% { background-color: #fafafa; border-color: #cbd5e1; }
            50% { background-color: #fff7ed; border-color: #ffd8a8; }
          }
          @keyframes shimmer {
            0% { background-position: 200% 0; }
            100% { background-position: -200% 0; }
          }
        `;
        this.shadowRoot.appendChild(spinStyle);
      }
      return;
    }

    const activeQuotes = this.getCalculatedQuotes();

    // Select default quote if none selected
    if (!this.selectedQuote && activeQuotes.length > 0) {
      this.selectedQuote = activeQuotes[0];
      this.selectedRate = activeQuotes[0]?.originalRate || null;
    } else if (this.selectedQuote) {
      const matched = activeQuotes.find(q => q.id === this.selectedQuote.id);
      this.selectedQuote = matched || activeQuotes[0];
      this.selectedRate = this.selectedQuote?.originalRate || null;
    }

    // Update quote totals text
    let pkgLabel = `${this.packageType}-Ball`;
    if (this.variants) {
      const matchedVariant = this.variants.find(v => String(v.id) === String(this.packageType));
      if (matchedVariant) {
        pkgLabel = matchedVariant.name;
      }
    }
    this.findEl('rates-count-subinfo').innerText = `${activeQuotes.length} services across carriers • for ${pkgLabel}, ${this.lbs} lbs to ${this.to}`;
    this.findEl('filter-all-btn').innerText = `All (${activeQuotes.length + (this.activeFilter !== 'all' ? 2 : 0)})`;

    // Render cheapest card box
    const cheapestQuote = activeQuotes.find(q => q.pick === true) || activeQuotes[0];
    const cheapestRoot = this.findEl('cheapest-rate-box-root');
    if (cheapestRoot && cheapestQuote) {
      cheapestRoot.innerHTML = '';
      const cheapestCard = this.createCarrierCard(cheapestQuote, true);
      cheapestRoot.appendChild(cheapestCard);
    }

    // Render other options carriers list
    const otherListRoot = this.findEl('other-carriers-list-root');
    if (otherListRoot) {
      otherListRoot.innerHTML = '';
      const others = activeQuotes.filter(q => q.id !== (cheapestQuote ? cheapestQuote.id : ''));
      others.forEach(quote => {
        const card = this.createCarrierCard(quote, false);
        otherListRoot.appendChild(card);
      });
    }

    // Footer button caption
    const btnContinue = this.findEl('btn-footer-continue-checkout');
    if (btnContinue) {
      btnContinue.innerHTML = '';
      const continueSpan = document.createElement('span');
      continueSpan.textContent = `Continue with ${this.selectedQuote ? this.selectedQuote.name : 'Selected carrier'} `;
      btnContinue.appendChild(continueSpan);
      btnContinue.appendChild(this.createSvgElement(ICONS.arrowRight));
      btnContinue.disabled = !this.selectedQuote;
    }
  }

  parseGooglePlace(place) {
    const address = {
      name: place.name || 'Ronald McDonald',
      street1: '',
      street2: '',
      city: '',
      state: '',
      country: 'US',
      zip: ''
    };

    let streetNumber = '';
    let route = '';

    if (place.address_components) {
      place.address_components.forEach(component => {
        const types = component.types;
        if (types.includes('street_number')) {
          streetNumber = component.long_name;
        } else if (types.includes('route')) {
          route = component.long_name;
        } else if (types.includes('locality')) {
          address.city = component.long_name;
        } else if (types.includes('administrative_area_level_1')) {
          address.state = component.short_name;
        } else if (types.includes('postal_code')) {
          address.zip = component.long_name;
        } else if (types.includes('country')) {
          address.country = component.short_name;
        }
      });
    }

    address.street1 = `${streetNumber} ${route}`.trim();
    if (!address.street1) {
      address.street1 = place.formatted_address || place.name || '';
    }
    return address;
  }

  parseAddressString(str) {
    if (str === 'Pickup location' || str === 'Any Destination' || !str) {
      return null;
    }
    const parts = str.split(',').map(p => p.trim());
    let name = '';
    let street1 = '';
    let street2 = '';
    let city = '';
    let state = '';
    let zip = '';
    let country = 'US';

    let firstPart = parts[0] || '';
    if (firstPart.includes(':')) {
      const nameAndStreet = firstPart.split(':');
      name = nameAndStreet[0].trim();
      street1 = nameAndStreet.slice(1).join(':').trim();
    } else {
      street1 = firstPart;
    }

    if (parts.length >= 3) {
      city = parts[1] || '';
      const stateZip = (parts[2] || '').split(' ').filter(Boolean);
      if (stateZip.length >= 2) {
        state = stateZip[0];
        zip = stateZip.slice(1).join(' ');
      } else if (stateZip.length === 1) {
        if (/\d/.test(stateZip[0])) {
          zip = stateZip[0];
        } else {
          state = stateZip[0];
        }
      }
      if (parts.length >= 4) {
        country = parts[3] || 'US';
      }
    } else if (parts.length === 2) {
      city = parts[1];
    }

    return {
      name: name || 'Ronald McDonald',
      street1: street1 || '1337 3rd Street Promenade',
      street2: street2 || '',
      city: city || 'Santa Monica',
      state: state || 'CA',
      country: country || 'US',
      zip: zip || '90401'
    };
  }

  async createShipmentOrder() {
    this.loading = true;
    this.render();

    try {
      const fromAddr = this.routes.find(r => r.id === 'origin');
      const toAddr = this.routes.find(r => r.id === 'destination');

      const address_from = fromAddr?.addressObj || this.parseAddressString(fromAddr?.value) || {};
      const address_to = toAddr?.addressObj || this.parseAddressString(toAddr?.value) || {};

      let weightVal = 2.5;
      let lengthVal = 12;
      let widthVal = 8;
      let heightVal = 8;

      if (this.variants) {
        const variant = this.variants.find(v => String(v.id) === String(this.packageType));
        if (variant) {
          lengthVal = Number(variant.length) || 12;
          widthVal = Number(variant.width) || 8;
          heightVal = Number(variant.height) || 8;
          weightVal = Number((variant.weight / 16).toFixed(1)) || 2.5;
        }
      }

      const payload = {
        salesChannel: "Amazon FBA",
        warehouseOrigin: "East Coast Node (TX)",
        orderReference: "#ORD-" + Math.floor(10000 + Math.random() * 90000),
        poNumber: "PO-" + Math.floor(10000 + Math.random() * 90000),
        fromAddress: {
          addressId: null,
          fullName: address_from.name || "Joe McCarthy",
          companyName: "",
          streetAddress: address_from.street1 || "10194 Crosspoint Blvd suite 300, Indianapolis, IN 46256",
          addressLine2: address_from.street2 || "",
          city: address_from.city || "Indianapolis",
          state: address_from.state || "Indiana",
          zipCode: address_from.zip || "46256",
          country: address_from.country || "US",
          addressType: "FROM",
          phoneNumber: address_from.phone || "13179226397",
          contactEmail: address_from.email || "jmcca@backhauldirect.com"
        },
        toAddress: {
          addressId: null,
          fullName: address_to.name || "IDCS",
          companyName: "",
          streetAddress: address_to.street1 || "1262 Simon Blvd, Easton, PA 18042",
          addressLine2: address_to.street2 || "B101",
          city: address_to.city || "Easton",
          state: address_to.state || "Pennsylvania",
          zipCode: address_to.zip || "18042",
          country: address_to.country || "US",
          addressType: "TO",
          phoneNumber: address_to.phone || "1234567891",
          contactEmail: address_to.email || "sendto@Shipdeez.com"
        },
        packages: [
          {
            packageId: null,
            weight: weightVal,
            length: lengthVal,
            width: widthVal,
            height: heightVal,
            weightUnit: "LB",
            dimensionUnit: "CM",
            shipDate: new Date().toISOString(),
            dimDivisor: 139,
            signature: "No Signature",
            insurance: "None",
            contentsDescription: "",
            referenceNumber: "",
            includeReturnLabel: false
          }
        ],
        deliveryOptions: {
          emailNotification: "",
          smsNotification: "",
          dropoffType: "Regular Pickup",
          saturdayDelivery: false,
          byOrder: false,
          earliestDeliveryDate: null,
          latestDeliveryDate: null,
          earliestPickupDate: null,
          latestPickupDate: null,
          handlingInstructions: null
        },
        shippingSettings: null
      };

      const response = await fetch('https://dev-api.shipdeez.com/api/v1/Shipment/create-shipment', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`Create shipment API status ${response.status}`);
      }

      const resJson = await response.json();
      const shipmentId = resJson?.data?.result?.shipmentId;

      if (!shipmentId) {
        throw new Error("Shipment creation did not return a valid shipmentId");
      }

      this.shipmentId = shipmentId;
      console.log("[LogisticsSDK] Created shipmentId successfully:", this.shipmentId);

      // Now fetch rates for step 2
      await this.fetchRates();

    } catch (err) {
      console.error('Failed to create shipment order:', err);
      this.loading = false;
      this.render();
    }
  }

  async fetchRates() {
    if (!this.shipmentId) {
      console.warn("No shipmentId available for fetching rates.");
      this.loading = false;
      this.render();
      return;
    }

    this.loading = true;
    this.render();

    try {
      const response = await fetch('https://dev-api.shipdeez.com/api/v1/Shipment/get-rates', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ shipmentId: this.shipmentId })
      });

      if (!response.ok) {
        throw new Error(`Get rates API status ${response.status}`);
      }

      const resJson = await response.json();
      const packagesResult = resJson?.data?.result || [];

      let rawQuotes = [];
      packagesResult.forEach(pkg => {
        if (pkg.quotes && Array.isArray(pkg.quotes)) {
          rawQuotes = rawQuotes.concat(pkg.quotes);
        }
      });

      if (rawQuotes.length > 0) {
        this.quotes = rawQuotes.map((q, index) => {
          const carrierKey = (q.carrier || '').toLowerCase().replace(/[^a-z]/g, '');
          const serviceName = q.service || 'GROUND';
          const rateAmount = parseFloat(q.rateAmount) || 0;

          let filterType = 'ground';
          const sLower = serviceName.toLowerCase();
          if (sLower.includes('overnight') || sLower.includes('2_day') || sLower.includes('air') || sLower.includes('priority')) {
            filterType = 'express';
          } else if (sLower.includes('saver') || sLower.includes('3_day') || sLower.includes('economy')) {
            filterType = 'economy';
          }

          return {
            id: q.shipmentQuoteId || (`quote_${index}`),
            carrier: carrierKey,
            name: serviceName,
            price: rateAmount,
            time: 'Standard Delivery',
            desc: `${q.carrier} - ${serviceName}`,
            eta: 'TBD',
            type: filterType,
            pick: index === 0,
            originalRate: q
          };
        });

        if (this.quotes.length > 0) {
          this.selectedQuote = this.quotes[0];
          this.selectedRate = this.quotes[0].originalRate || null;
        } else {
          this.selectedQuote = null;
          this.selectedRate = null;
        }
      } else {
        this.quotes = [];
        this.selectedQuote = null;
        this.selectedRate = null;
      }
    } catch (err) {
      console.error('Failed to fetch rates:', err);
      this.quotes = [];
      this.selectedQuote = null;
      this.selectedRate = null;
    } finally {
      this.loading = false;
      this.render();
    }
  }

  async initInlineStripeCheckout(totalAmount, modalMain) {
    if (this._currentCheckoutShipmentId === this.shipmentId && this.paymentMeta) {
      // Re-mount existing payment element without calling API again
      if (this.stripeInstance && this.paymentMeta.clientSecret) {
        try {
          const loader = modalMain.querySelector('#stripe-inline-loader');
          const placeholder = modalMain.querySelector('#stripe-payment-element-mount');
          if (placeholder) {
            if (loader) loader.style.display = 'none';
            const lightMount = this.getStripeLightDomMount();
            this.syncStripeLightDomMountPosition();
            this.startStripeLightDomSync();
            if (!this._stripeElementMounted) {
              this.stripeElements = this.stripeInstance.elements({
                clientSecret: this.paymentMeta.clientSecret,
                wallets: {
                  link: 'never'
                },
                appearance: {
                  theme: 'flat',
                  variables: {
                    colorPrimary: '#ea580c',
                    borderRadius: '12px'
                  }
                }
              });
              const paymentElement = this.stripeElements.create('payment');
              this._stripePaymentElement = paymentElement;
              paymentElement.on('ready', () => {
                this._paymentElementReady = true;
                const payBtn = this.findEl('btn-pay-now');
                const consentCheckbox = this.findEl('consent-checkbox');
                if (payBtn && consentCheckbox) {
                  payBtn.disabled = !consentCheckbox.checked || this.payNowLoading;
                }
              });
              paymentElement.on('loaderror', (event) => {
                console.error("Stripe Payment Element load error:", event);
                if (loader) {
                  loader.style.display = 'block';
                  loader.innerHTML = `<span style="color: #ef4444;">Failed to load payment options: ${event.error?.message || 'Unknown error'}</span>`;
                }
              });
              paymentElement.mount(lightMount);
              this._stripeElementMounted = true;
            }
          }
          return;
        } catch (e) {
          console.warn("Failed to remount existing payment element:", e);
        }
      }
    }

    if (this._checkoutLoading) return;
    this._checkoutLoading = true;
    this._currentCheckoutShipmentId = this.shipmentId;
    this._stripeElementMounted = false;

    try {
      const checkoutPayload = {
        amount: Number(totalAmount.toFixed(2)),
        paymentMethod: "card",
        shipmentId: this.shipmentId,
        merchantId: this.shipmentMetaResult?.merchantId || 1,
        currencyCode: this.shipmentMetaResult?.currency || "USD",
        origin: typeof window !== 'undefined' ? window.location.origin : "https://dev.shipdeez.com"
      };

      const checkoutRes = await fetch('https://dev-api.shipdeez.com/api/v1/Payment/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(checkoutPayload)
      });

      if (!checkoutRes.ok) throw new Error(`Payment checkout status ${checkoutRes.status}`);

      const checkoutJson = await checkoutRes.json();
      const checkoutResult = checkoutJson?.data?.result || checkoutJson?.result || checkoutJson?.data;

      const clientSecret = checkoutResult?.clientSecret;

      if (!checkoutResult || !clientSecret) {
        console.warn("No clientSecret in payment checkout result:", checkoutJson);
        const loader = modalMain.querySelector('#stripe-inline-loader');
        if (loader) loader.innerHTML = `<span style="color: #ef4444;">Unable to initialize payment session.</span>`;
        return;
      }

      this.paymentMeta = checkoutResult;

      // Lazy load Stripe.js (supports Stripe's versioned URL)
      try {
        await this.sdk.lazyLoadScript('https://js.stripe.com/dahlia/stripe.js');
      } catch (e) {
        await this.sdk.lazyLoadScript('https://js.stripe.com/v3/');
      }
      if (!window.Stripe) {
        throw new Error("Stripe.js failed to load");
      }

      const stripeKey = checkoutResult.publishableKey || checkoutResult.stripeKey || window.STRIPE_PUBLISHABLE_KEY || this.sdk.config?.stripePublishableKey || 'pk_test_51T94P52eFHMnk4Mbv0yH7VPMmNeQQOPWFHZf0cnCOIdbN7cUd1J6d3zlyZBgYHz89VhQ4tvt0nQNBJjJOTePKy2600BAqTqCwd';
      this.stripeInstance = window.Stripe(stripeKey);

      this.stripeElements = this.stripeInstance.elements({
        clientSecret: clientSecret,
        wallets: {
          link: 'never'
        },
        appearance: {
          theme: 'flat',
          variables: {
            colorPrimary: '#ea580c',
            borderRadius: '12px'
          }
        }
      });

      const paymentElement = this.stripeElements.create('payment');
      this._stripePaymentElement = paymentElement;
      const loader = modalMain.querySelector('#stripe-inline-loader');
      const placeholder = modalMain.querySelector('#stripe-payment-element-mount');

      paymentElement.on('ready', () => {
        this._paymentElementReady = true;
        const payBtn = this.findEl('btn-pay-now');
        const consentCheckbox = this.findEl('consent-checkbox');
        if (payBtn && consentCheckbox) {
          payBtn.disabled = !consentCheckbox.checked || this.payNowLoading;
        }
      });

      paymentElement.on('loaderror', (event) => {
        console.error("Stripe Payment Element load error:", event);
        if (loader) {
          loader.style.display = 'block';
          loader.innerHTML = `<span style="color: #ef4444;">Failed to load payment options: ${event.error?.message || 'Unknown error'}</span>`;
        }
      });

      if (placeholder) {
        // Mount into a light-DOM node overlaying the shadow-DOM placeholder — Stripe's
        // Payment Element never becomes ready when mounted directly inside a Shadow DOM.
        const lightMount = this.getStripeLightDomMount();
        this.syncStripeLightDomMountPosition();
        this.startStripeLightDomSync();
        paymentElement.mount(lightMount);
        this._stripeElementMounted = true;
        if (loader) loader.style.display = 'none';
      }
    } catch (err) {
      console.error("Failed to initialize inline Stripe checkout:", err);
      const loader = modalMain.querySelector('#stripe-inline-loader');
      if (loader) loader.innerHTML = `<span style="color: #ef4444;">Failed to load payment options. ${err.message || ''}</span>`;
    } finally {
      this._checkoutLoading = false;
    }
  }

  // Handle Payment Checkout and Verification flow
  async createShipment() {
    if (!this.consentChecked) {
      this.showCheckoutError('Please confirm shipping terms to continue.');
      return;
    }

    if (!this._paymentElementReady) {
      this.showCheckoutError('Please wait for payment options to load completely.');
      return;
    }

    this.payNowLoading = true;
    const payBtn = this.findEl('btn-pay-now');
    if (payBtn) {
      payBtn.disabled = true;
      payBtn.innerHTML = '<span class="pay-now-spinner"></span><span>Confirming Payment...</span>';
    }

    try {
      if (this.stripeInstance && this.stripeElements && this.paymentMeta) {
        const { error } = await this.stripeInstance.confirmPayment({
          elements: this.stripeElements,
          confirmParams: {
            return_url: window.location.href,
          },
          redirect: 'if_required'
        });

        if (error) {
          console.error("Stripe confirmPayment error:", error);
          this.showCheckoutError(error.message || "Payment confirmation failed");
          this.payNowLoading = false;
          if (payBtn) {
            payBtn.disabled = false;
            payBtn.innerHTML = '<span>Pay Now</span>';
          }
          return;
        }

        // Payment authorized → tear down the Stripe Payment Element (and any of its own
        // overlays, e.g. the Link "Success" toast) before moving on, since it lives in a
        // light-DOM node outside this widget's shadow root and won't go away on its own.
        this.destroyStripeLightDomMount();
        this.step = 3.5;
        this.renderVerificationScreen(this.paymentMeta.sessionId, this.paymentMeta.paymentRefId);
        return;
      }

      // Fallback checkout if Elements was not pre-mounted
      const meta = this.shipmentMetaResult;
      const rateAmtVal = meta?.rateAmount !== undefined ? Number(meta.rateAmount) : (this.selectedRate ? parseFloat(this.selectedRate.rateAmount || this.selectedRate.price || 0) : 0);
      const totalAmount = rateAmtVal + 0.99;

      const checkoutPayload = {
        amount: Number(totalAmount.toFixed(2)),
        paymentMethod: "card",
        shipmentId: this.shipmentId,
        merchantId: meta?.merchantId || 1,
        currencyCode: meta?.currency || "USD",
        origin: typeof window !== 'undefined' ? window.location.origin : "https://dev.shipdeez.com"
      };

      const checkoutRes = await fetch('https://dev-api.shipdeez.com/api/v1/Payment/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(checkoutPayload)
      });

      if (!checkoutRes.ok) throw new Error(`Payment checkout status ${checkoutRes.status}`);

      const checkoutJson = await checkoutRes.json();
      const checkoutResult = checkoutJson?.data?.result;

      if (!checkoutResult || !checkoutResult.sessionId || !checkoutResult.paymentRefId) {
        throw new Error('Payment checkout failed: missing sessionId or paymentRefId');
      }

      this.step = 3.5;
      this.renderVerificationScreen(checkoutResult.sessionId, checkoutResult.paymentRefId);

    } catch (err) {
      console.error('Payment checkout failed:', err);
      this.payNowLoading = false;
      this.showCheckoutError(err.message || 'Payment processing failed. Please try again.');
      if (payBtn) {
        payBtn.disabled = false;
        payBtn.innerHTML = '<span>Pay Now</span>';
      }
    }
  }

  renderStripeElementsModal(stripe, clientSecret, sessionId, paymentRefId) {
    const modalMain = this.modalOverlayWrapper?.shadowRoot?.querySelector('.rates-modal-main') || this.shadowRoot.querySelector('.rates-modal-main');
    if (!modalMain) return;

    modalMain.innerHTML = `
      <div style="padding: 10px 0;">
        <h3 style="font-size: 16px; font-weight: 700; color: #0f172a; margin-bottom: 12px;">Complete Payment with Stripe</h3>
        <div id="stripe-payment-element-mount" style="min-height: 250px; background: #ffffff; padding: 16px; border: 1px solid #e2e8f0; border-radius: 12px; margin-bottom: 20px;"></div>
        <button type="button" id="btn-submit-stripe-payment" class="btn-pay-now">
          <span>Confirm & Pay</span>
        </button>
      </div>
    `;

    try {
      const elements = stripe.elements({ clientSecret, appearance: { theme: 'stripe' } });
      const paymentElement = elements.create('payment');
      const mountNode = modalMain.querySelector('#stripe-payment-element-mount');
      paymentElement.mount(mountNode);

      const submitBtn = modalMain.querySelector('#btn-submit-stripe-payment');
      if (submitBtn) {
        submitBtn.addEventListener('click', async () => {
          submitBtn.disabled = true;
          submitBtn.innerHTML = '<span class="pay-now-spinner"></span><span>Confirming Payment...</span>';

          const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
              return_url: window.location.href,
            },
            redirect: 'if_required'
          });

          if (error) {
            console.error("Stripe confirmPayment error:", error);
            alert(error.message || "Payment confirmation failed");
            submitBtn.disabled = false;
            submitBtn.innerHTML = '<span>Confirm & Pay</span>';
          } else {
            // Payment succeeded without redirect → proceed to verification step
            this.step = 3.5;
            this.renderVerificationScreen(sessionId, paymentRefId);
          }
        });
      }
    } catch (e) {
      console.error("Failed to mount Stripe Payment Element:", e);
      this.step = 3.5;
      this.renderVerificationScreen(sessionId, paymentRefId);
    }
  }

  renderVerificationScreen(sessionId, paymentRefId) {
    const modalMain = this.modalOverlayWrapper?.shadowRoot?.querySelector('.rates-modal-main') || this.shadowRoot.querySelector('.rates-modal-main');
    if (!modalMain) return;

    modalMain.innerHTML = `
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 40px 20px; text-align: center;">
        <div class="loading-spinner-glow" style="width: 56px; height: 56px; border: 4px solid #f1f5f9; border-top-color: #f97316; border-radius: 50%; animation: spin 0.8s linear infinite; margin-bottom: 24px;"></div>
        <h2 style="font-size: 22px; font-weight: 800; color: #0f172a; margin-bottom: 8px;">Verifying Payment</h2>
        <p style="font-size: 13px; color: #64748b; font-weight: 500; margin-bottom: 24px;">Please wait — do not close this page</p>

        <div style="display: flex; flex-direction: column; gap: 12px; width: 100%; max-width: 400px; text-align: left;">
          <div id="verify-step-1" style="display: flex; align-items: center; gap: 10px; padding: 12px 16px; border-radius: 30px; border: 1px solid #e2e8f0; background: #ffffff; font-size: 13px; font-weight: 700; color: #0f172a;">
            <span style="display: inline-flex; align-items: center; justify-content: center; width: 20px; height: 20px; border-radius: 50%; background: #dcfce7; color: #16a34a; font-size: 12px;">✓</span>
            Payment authorized
          </div>
          <div id="verify-step-2" style="display: flex; align-items: center; gap: 10px; padding: 12px 16px; border-radius: 30px; border: 1px solid #e2e8f0; background: #ffffff; font-size: 13px; font-weight: 700; color: #0f172a;">
            <span style="display: inline-flex; align-items: center; justify-content: center; width: 20px; height: 20px; border-radius: 50%; background: #dcfce7; color: #16a34a; font-size: 12px;">✓</span>
            Shipment record created
          </div>
          <div id="verify-step-3" style="display: flex; align-items: center; gap: 10px; padding: 12px 16px; border-radius: 30px; border: 1px solid #e2e8f0; background: #ffffff; font-size: 13px; font-weight: 700; color: #0f172a;">
            <span style="display: inline-flex; align-items: center; justify-content: center; width: 20px; height: 20px; border-radius: 50%; background: #dcfce7; color: #16a34a; font-size: 12px;">✓</span>
            Label generation queued
          </div>
        </div>
      </div>
    `;

    // Execute validate API call & prepare-payment
    this.executePaymentValidation(sessionId, paymentRefId);
  }

  async executePaymentValidation(sessionId, paymentRefId) {
    try {
      // 2. Call Payment Validate API
      // NOTE: this endpoint always responds HTTP 200 — real success/failure is encoded in the
      // JSON body (`isSuccessful` / `data.result.paymentStatus`), not the HTTP status, so
      // `validateRes.ok` alone can never detect a failed validation.
      const validateRes = await fetch('https://dev-api.shipdeez.com/api/v1/Payment/validate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId, paymentRefId })
      });

      if (!validateRes.ok) {
        throw new Error(`Payment validation status ${validateRes.status}`);
      }

      const validateJson = await validateRes.json();
      console.log("[LogisticsSDK] Payment validation result:", validateJson);

      const paymentStatus = validateJson?.data?.result?.paymentStatus;
      if (validateJson?.isSuccessful === false || paymentStatus === 'FAILED') {
        console.error('[LogisticsSDK] Payment validation reported failure:', validateJson?.errorMessages);
        this.renderPaymentFailedScreen('We couldn\'t confirm your payment. Your card has not been charged twice — please contact support if you were charged, or try again.');
        return;
      }

      // 3. Call Prepare-Payment API to get all meta information
      const prepareRes = await fetch('https://dev-api.shipdeez.com/api/v1/Shipment/prepare-payment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ shipmentId: this.shipmentId })
      });

      if (!prepareRes.ok) {
        throw new Error(`Prepare payment status ${prepareRes.status}`);
      }

      const prepareJson = await prepareRes.json();
      if (prepareJson?.isSuccessful === false) {
        console.error('[LogisticsSDK] Prepare-payment reported failure:', prepareJson?.errorMessages);
        this.renderPaymentFailedScreen('Your payment was confirmed, but we ran into an issue preparing your label. Please contact support with your payment reference.');
        return;
      }

      this.shipmentMetaResult = prepareJson?.data?.result || null;
      console.log("[LogisticsSDK] Prepare payment meta details:", this.shipmentMetaResult);

      // Advance to final Step 4 Label Ready screen
      this.step = 4;
      this.render();

    } catch (err) {
      console.error('Payment validation / prepare-payment failed:', err);
      this.renderPaymentFailedScreen(err.message || 'Failed to complete shipment label.');
    }
  }

  // Shown when Payment/validate or prepare-payment reports a real failure (HTTP 200 with
  // isSuccessful:false / paymentStatus:"FAILED"), or a genuine network/exception error.
  renderPaymentFailedScreen(message) {
    const modalMain = this.modalOverlayWrapper?.shadowRoot?.querySelector('.rates-modal-main') || this.shadowRoot.querySelector('.rates-modal-main');
    if (!modalMain) return;

    modalMain.innerHTML = `
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 40px 20px; text-align: center;">
        <div style="width: 56px; height: 56px; border-radius: 50%; background: #fee2e2; color: #ef4444; display: flex; align-items: center; justify-content: center; font-size: 28px; margin-bottom: 24px;">✕</div>
        <h2 style="font-size: 22px; font-weight: 800; color: #0f172a; margin-bottom: 8px;">Payment Verification Failed</h2>
        <p style="font-size: 13px; color: #64748b; font-weight: 500; margin-bottom: 24px; max-width: 400px;">${message}</p>
        <button type="button" id="btn-payment-failed-back" class="btn-pay-now" style="max-width: 240px;">
          <span>Back to Checkout</span>
        </button>
      </div>
    `;

    const backBtn = modalMain.querySelector('#btn-payment-failed-back');
    if (backBtn) {
      backBtn.addEventListener('click', () => {
        this.step = 3;
        this.render();
      });
    }
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  showCheckoutError(message) {
    const banner = this.findEl('checkout-error-banner-root');
    if (!banner) return;
    banner.innerHTML = '';
    banner.style.cssText = 'z-index:9999999999999 !important; position: fixed; bottom: 20px; left: 20px;';
    const errDiv = document.createElement('div');
    errDiv.style.cssText = 'background: #dc2626; border: 1px solid #fca5a5; border-radius: 8px; padding: 12px 16px; margin-bottom: 16px; font-size: 13px; color: #fef2f2; font-weight: 500; display: flex; align-items: center; gap: 8px;';
    errDiv.innerHTML = `<span style="font-size: 16px;">⚠</span> ${message}`;
    banner.appendChild(errDiv);

    // Auto - dismiss after 6 seconds
    setTimeout(() => {
      if (banner.contains(errDiv)) banner.removeChild(errDiv);
    }, 12000);
  }

  getCalculatedQuotes() {
    const results = this.quotes || [];
    if (this.activeFilter === 'all') return results;
    return results.filter(q => q.type === this.activeFilter);
  }

  async processSelectedRate(btnContinue) {
    btnContinue.disabled = true;
    btnContinue.innerHTML = `<span>Selecting rate...</span>`;

    try {
      const payload = {
        shipmentId: this.shipmentId,
        selectedRates: [
          {
            shipmentQuoteId: this.selectedRate.shipmentQuoteId,
            packageId: this.selectedRate.extShipmentId,
            carrierData: {
              shipmentQuoteId: this.selectedRate.shipmentQuoteId,
              carrier: this.selectedRate.carrier,
              service: this.selectedRate.service,
              rateAmount: String(this.selectedRate.rateAmount),
              currency: this.selectedRate.currency || "USD",
              extRateId: this.selectedRate.extRateId,
              extShipmentId: this.selectedRate.extShipmentId
            }
          }
        ]
      };

      const response = await fetch('https://dev-api.shipdeez.com/api/v1/Shipment/select-rate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`Select rate API status ${response.status}`);
      }

      console.log('[LogisticsSDK] Select rate succeeded');

      // Fetch prepare-payment details to populate billing breakdown & address preview
      try {
        const prepareRes = await fetch('https://dev-api.shipdeez.com/api/v1/Shipment/prepare-payment', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ shipmentId: this.shipmentId })
        });
        if (prepareRes.ok) {
          const prepareJson = await prepareRes.json();
          this.shipmentMetaResult = prepareJson?.data?.result || null;
          console.log('[LogisticsSDK] Prepare payment details fetched for checkout:', this.shipmentMetaResult);
        }
      } catch (e) {
        console.warn('[LogisticsSDK] Failed to prefetch prepare-payment details:', e);
      }

      this.step = 3;
      this.render();

    } catch (err) {
      console.error('Failed to select rate:', err);
      alert('Failed to select rate. Please try again.');
    } finally {
      btnContinue.disabled = false;
    }
  }

  bindEvents() {
    // Step 1 Horizontal Form handlers
    const barForm = this.findEl('quote-horizontal-bar');
    if (barForm && !barForm.dataset.listenerBound) {
      barForm.dataset.listenerBound = 'true';
      barForm.addEventListener('submit', (e) => {
        e.preventDefault();
        this.routes.forEach(row => {
          const input = this.findEl(row.id + '-input');
          if (input) {
            row.value = input.value || row.placeholder;
          }
        });
        this.step = 2;
        this.createShipmentOrder();
      });
    }

    // Dropdown toggle and selection
    const dropdownContainer = this.findEl('bag-dropdown-container');
    const dropdownTrigger = this.findEl('bag-dropdown-trigger');
    const dropdownMenu = this.findEl('bag-dropdown-menu');

    if (dropdownTrigger && dropdownMenu) {
      if (!dropdownTrigger.dataset.listenerBound) {
        dropdownTrigger.dataset.listenerBound = 'true';
        dropdownTrigger.addEventListener('click', (e) => {
          e.stopPropagation();
          dropdownMenu.classList.toggle('show');
          dropdownContainer?.classList.toggle('open');
        });

        document.addEventListener('click', (e) => {
          const path = e.composedPath ? e.composedPath() : [];
          if (!path.includes(dropdownContainer)) {
            dropdownMenu?.classList.remove('show');
            dropdownContainer?.classList.remove('open');
          }
        });
      }

      const dropdownItems = dropdownMenu.querySelectorAll('.dropdown-item');
      dropdownItems.forEach(item => {
        item.addEventListener('click', (e) => {
          this.routes.forEach(row => {
            const input = this.findEl(row.id + '-input');
            if (input) {
              row.value = input.value || row.placeholder;
            }
          });

          this.packageType = e.currentTarget.getAttribute('data-pkg');
          if (this.variants) {
            const variant = this.variants.find(v => String(v.id) === String(this.packageType));
            this.updateWeightFromVariant(variant);
          }
          dropdownMenu.classList.remove('show');
          dropdownContainer?.classList.remove('open');
          this.render();
        });
      });
    }

    // Step 2 Modal Rates controls
    const btnCloseRates = this.findEl('btn-close-rates-modal');
    if (btnCloseRates) {
      btnCloseRates.addEventListener('click', () => { this.step = 1; this.render(); });
    }

    const btnEditRoute = this.findEl('btn-sidebar-edit-route');
    if (btnEditRoute) {
      btnEditRoute.addEventListener('click', (e) => {
        e.preventDefault();
        if (!this.sdk.auth.isLoggedIn()) {
          this.sdk.triggerAuth((authenticated) => {
            if (authenticated) {
              this.openAddressBook('origin', 'SENDER');
            }
          });
        } else {
          this.openAddressBook('origin', 'SENDER');
        }
      });
    }

    const btnFooterBack = this.findEl('btn-footer-back');
    if (btnFooterBack) {
      btnFooterBack.onclick = () => {
        if (this.step === 3) {
          this.step = 2;
        } else {
          this.step = 1;
        }

        this.render();
      };
    }

    // Sidebar Package triggers
    const pkgSideCards = this.findEls('.pkg-card-sidebar');
    pkgSideCards.forEach(card => {
      card.addEventListener('click', (e) => {
        const pkgVal = e.currentTarget.getAttribute('data-pkg');
        if (this.packageType === pkgVal) return;
        this.packageType = pkgVal;
        if (pkgVal === 'custom') {
          this.lbs = Math.floor(this.customWeight / 16);
          this.oz = Math.round(this.customWeight % 16);
        } else if (this.variants) {
          const variant = this.variants.find(v => String(v.id) === String(this.packageType));
          this.updateWeightFromVariant(variant);
        }
        if (this.step === 2) {
          this.createShipmentOrder();
        }
      });
    });

    // Custom package form inputs and switch standard button
    if (this.packageType === 'custom') {
      const lengthInput = this.findEl('custom-length-input');
      const widthInput = this.findEl('custom-width-input');
      const heightInput = this.findEl('custom-height-input');
      const weightInput = this.findEl('custom-weight-input');
      const btnSwitchStandard = this.findEl('btn-switch-standard');

      if (lengthInput) {
        lengthInput.addEventListener('input', (e) => {
          this.customLength = parseFloat(e.target.value) || 0;
          this.render();
        });
        lengthInput.addEventListener('change', () => {
          if (this.step === 2) this.createShipmentOrder();
        });
      }
      if (widthInput) {
        widthInput.addEventListener('input', (e) => {
          this.customWidth = parseFloat(e.target.value) || 0;
          this.render();
        });
        widthInput.addEventListener('change', () => {
          if (this.step === 2) this.createShipmentOrder();
        });
      }
      if (heightInput) {
        heightInput.addEventListener('input', (e) => {
          this.customHeight = parseFloat(e.target.value) || 0;
          this.render();
        });
        heightInput.addEventListener('change', () => {
          if (this.step === 2) this.createShipmentOrder();
        });
      }
      if (weightInput) {
        weightInput.addEventListener('input', (e) => {
          this.customWeight = (parseFloat(e.target.value) || 0) * 16;
          this.lbs = Math.floor(this.customWeight / 16);
          this.oz = Math.round(this.customWeight % 16);
          this.render();
        });
        weightInput.addEventListener('change', () => {
          if (this.step === 2) this.createShipmentOrder();
        });
      }
      if (btnSwitchStandard) {
        btnSwitchStandard.addEventListener('click', () => {
          if (this.variants && this.variants.length > 0) {
            this.packageType = String(this.variants[0].id);
            this.updateWeightFromVariant(this.variants[0]);
          } else {
            this.packageType = '1';
          }
          this.render();
          if (this.step === 2) this.createShipmentOrder();
        });
      }
    }

    // Lbs buttons
    const btnLbsMinus = this.findEl('weight-lbs-minus');
    const btnLbsPlus = this.findEl('weight-lbs-plus');
    if (btnLbsMinus && btnLbsPlus) {
      btnLbsMinus.addEventListener('click', () => { this.lbs = Math.max(0, this.lbs - 1); this.render(); });
      btnLbsPlus.addEventListener('click', () => { this.lbs = this.lbs + 1; this.render(); });
    }

    // Oz buttons
    const btnOzMinus = this.findEl('weight-oz-minus');
    const btnOzPlus = this.findEl('weight-oz-plus');
    if (btnOzMinus && btnOzPlus) {
      btnOzMinus.addEventListener('click', () => {
        if (this.oz <= 0) {
          if (this.lbs > 0) { this.lbs = this.lbs - 1; this.oz = 15; }
        } else { this.oz = this.oz - 1; }
        this.render();
      });
      btnOzPlus.addEventListener('click', () => {
        if (this.oz >= 15) { this.lbs = this.lbs + 1; this.oz = 0; }
        else { this.oz = this.oz + 1; }
        this.render();
      });
    }

    // Dropdowns and checks
    const deliverySelect = this.findEl('delivery-confirmation-select');
    if (deliverySelect) {
      deliverySelect.addEventListener('change', (e) => { this.deliveryConfirmation = e.target.value; });
    }

    const toggleRes = this.findEl('toggle-residential');
    if (toggleRes) {
      toggleRes.addEventListener('click', () => {
        this.isResidential = !this.isResidential;
        this.render();
        if (this.step === 2) this.createShipmentOrder();
      });
    }

    const toggleIns = this.findEl('toggle-insurance');
    if (toggleIns) {
      toggleIns.addEventListener('click', () => {
        this.isInsured = !this.isInsured;
        this.render();
        if (this.step === 2) this.createShipmentOrder();
      });
    }

    // Carrier selectors
    const carrierCards = this.findEls('.carrier-row-card, .cheapest-featured-box, .btn-carrier-select-trigger');
    carrierCards.forEach(card => {
      card.addEventListener('click', (e) => {
        e.stopPropagation();
        const carrierId = e.currentTarget.getAttribute('data-carrier-id');
        const quotes = this.getCalculatedQuotes();
        const found = quotes.find(q => q.id === carrierId) || null;
        this.selectedQuote = found;
        this.selectedRate = found?.originalRate || null;  // Keep selectedRate in sync
        this.render();
      });
    });

    // Tabs filter triggers
    const filterTabs = this.findEls('.filter-tab-button');
    filterTabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        this.activeFilter = e.currentTarget.getAttribute('data-filter');
        this.render();
      });
    });

    // Continue action button (Step 2 → Step 3)
    const btnContinue = this.findEl('btn-footer-continue-checkout');
    if (btnContinue && !btnContinue.dataset.listenerBound) {
      btnContinue.dataset.listenerBound = 'true';
      btnContinue.addEventListener('click', () => {
        if (!this.selectedQuote || !this.selectedRate || !this.shipmentId) return;

        if (!this.sdk.auth.isLoggedIn()) {
          this.sdk.triggerAuth((authenticated) => {
            if (authenticated) {
              this.processSelectedRate(btnContinue);
            }
          });
          return;
        }

        this.processSelectedRate(btnContinue);
      });
    }

    // Step 3 Checkout — sender/receiver field sync
    const senderNameInput = this.findEl('sender-name');
    const senderEmailInput = this.findEl('sender-email');
    const senderPhoneInput = this.findEl('sender-phone');
    const receiverNameInput = this.findEl('receiver-name');
    const receiverEmailInput = this.findEl('receiver-email');
    const receiverPhoneInput = this.findEl('receiver-phone');
    const consentCheckbox = this.findEl('consent-checkbox');
    const payNowBtn = this.findEl('btn-pay-now');

    if (senderNameInput) {
      senderNameInput.addEventListener('input', (e) => { this.senderInfo.name = e.target.value; });
    }
    if (senderEmailInput) {
      senderEmailInput.addEventListener('input', (e) => { this.senderInfo.email = e.target.value; });
    }
    if (senderPhoneInput) {
      senderPhoneInput.addEventListener('input', (e) => { this.senderInfo.phone = e.target.value; });
    }
    if (receiverNameInput) {
      receiverNameInput.addEventListener('input', (e) => { this.receiverInfo.name = e.target.value; });
    }
    if (receiverEmailInput) {
      receiverEmailInput.addEventListener('input', (e) => { this.receiverInfo.email = e.target.value; });
    }
    if (receiverPhoneInput) {
      receiverPhoneInput.addEventListener('input', (e) => { this.receiverInfo.phone = e.target.value; });
    }

    if (consentCheckbox) {
      consentCheckbox.addEventListener('change', (e) => {
        this.consentChecked = e.target.checked;
        if (payNowBtn) {
          payNowBtn.disabled = !this.consentChecked || this.payNowLoading;
        }
      });
    }

    if (payNowBtn && !payNowBtn.dataset.listenerBound) {
      payNowBtn.dataset.listenerBound = 'true';
      payNowBtn.addEventListener('click', () => {
        // Sync final field values before submitting
        if (senderNameInput) this.senderInfo.name = senderNameInput.value;
        if (senderEmailInput) this.senderInfo.email = senderEmailInput.value;
        if (senderPhoneInput) this.senderInfo.phone = senderPhoneInput.value;
        if (receiverNameInput) this.receiverInfo.name = receiverNameInput.value;
        if (receiverEmailInput) this.receiverInfo.email = receiverEmailInput.value;
        if (receiverPhoneInput) this.receiverInfo.phone = receiverPhoneInput.value;

        this.createShipment();
      });
    }

    // Step 4 success buttons
    const btnSuccessDownload = this.findEl('btn-success-download');
    if (btnSuccessDownload && this.shipmentResult?.labelUrl) {
      btnSuccessDownload.addEventListener('click', () => {
        window.open(this.shipmentResult.labelUrl, '_blank');
      });
    }

    const btnSuccessPrint = this.findEl('btn-success-print');
    if (btnSuccessPrint && this.shipmentResult?.labelUrl) {
      btnSuccessPrint.addEventListener('click', () => {
        window.open(this.shipmentResult.labelUrl, '_blank');
      });
    }


    const btnResetSuccess = this.findEl('btn-success-reset');
    if (btnResetSuccess) {
      btnResetSuccess.addEventListener('click', () => {
        this.step = 1;
        this.from = 'Pickup location';
        this.to = 'Any Destination';
        if (this.variants && this.variants.length > 0) {
          this.packageType = String(this.variants[0].id);
          this.updateWeightFromVariant(this.variants[0]);
        } else {
          this.packageType = '1';
          this.lbs = 17;
          this.oz = 0;
        }
        this.isResidential = true;
        this.isInsured = true;
        this.deliveryConfirmation = 'none';
        this.selectedQuote = null;
        this.selectedRate = null;
        this.paymentError = '';
        this.quotes = [];
        this.senderInfo = { name: '', email: '', phone: '' };
        this.receiverInfo = { name: '', email: '', phone: '' };
        this.consentChecked = false;
        this.payNowLoading = false;
        this.shipmentResult = null;
        this.render();
      });
    }
  }
}
